
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("3zqta", function(module, exports) {

$parcel$export(module.exports, "createExpression", () => create$4);
$parcel$export(module.exports, "template", () => create);
/* Riot WIP, @license MIT */ 
var $fGGec = parcelRequire("fGGec");

var $8VupT = parcelRequire("8VupT");

var $f4jRS = parcelRequire("f4jRS");

var $dNFiL = parcelRequire("dNFiL");

var $3h6d1 = parcelRequire("3h6d1");

var $8kAdV = parcelRequire("8kAdV");

var $koC5P = parcelRequire("koC5P");
const HEAD_SYMBOL = Symbol();
const TAIL_SYMBOL = Symbol();
/**
 * Create the <template> fragments text nodes
 * @return {Object} {{head: Text, tail: Text}}
 */ function createHeadTailPlaceholders() {
    const head = document.createTextNode('');
    const tail = document.createTextNode('');
    head[HEAD_SYMBOL] = true;
    tail[TAIL_SYMBOL] = true;
    return {
        head: head,
        tail: tail
    };
}
/**
 * Create the template meta object in case of <template> fragments
 * @param   {TemplateChunk} componentTemplate - template chunk object
 * @returns {Object} the meta property that will be passed to the mount function of the TemplateChunk
 */ function createTemplateMeta(componentTemplate) {
    const fragment = componentTemplate.dom.cloneNode(true);
    const { head, tail } = createHeadTailPlaceholders();
    return {
        avoidDOMInjection: true,
        fragment: fragment,
        head: head,
        tail: tail,
        children: [
            head,
            ...Array.from(fragment.childNodes),
            tail
        ]
    };
}
/* c8 ignore start */ /**
 * ISC License
 *
 * Copyright (c) 2020, Andrea Giammarchi, @WebReflection
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
 * AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
 * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
 * LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE
 * OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
 * PERFORMANCE OF THIS SOFTWARE.
 */ // fork of https://github.com/WebReflection/udomdiff version 1.1.0
// due to https://github.com/WebReflection/udomdiff/pull/2
/* eslint-disable */ /**
 * @param {Node[]} a The list of current/live children
 * @param {Node[]} b The list of future children
 * @param {(entry: Node, action: number) => Node} get
 * The callback invoked per each entry related DOM operation.
 * @param {Node} [before] The optional node used as anchor to insert before.
 * @returns {Node[]} The same list of future children.
 */ const udomdiff = (a, b, get, before)=>{
    const bLength = b.length;
    let aEnd = a.length;
    let bEnd = bLength;
    let aStart = 0;
    let bStart = 0;
    let map = null;
    while(aStart < aEnd || bStart < bEnd){
        // append head, tail, or nodes in between: fast path
        if (aEnd === aStart) {
            // we could be in a situation where the rest of nodes that
            // need to be added are not at the end, and in such case
            // the node to `insertBefore`, if the index is more than 0
            // must be retrieved, otherwise it's gonna be the first item.
            const node = bEnd < bLength ? bStart ? get(b[bStart - 1], -0).nextSibling : get(b[bEnd - bStart], 0) : before;
            while(bStart < bEnd)(0, $fGGec.insertBefore)(get(b[bStart++], 1), node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            // remove the node only if it's unknown or not live
            if (!map || !map.has(a[aStart])) (0, $fGGec.removeChild)(get(a[aStart], -1));
            aStart++;
        }
        else if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
        } else if (a[aEnd - 1] === b[bEnd - 1]) {
            aEnd--;
            bEnd--;
        } else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            // this is a "shrink" operation that could happen in these cases:
            // [1, 2, 3, 4, 5]
            // [1, 4, 3, 2, 5]
            // or asymmetric too
            // [1, 2, 3, 4, 5]
            // [1, 2, 3, 5, 6, 4]
            const node = get(a[--aEnd], -1).nextSibling;
            (0, $fGGec.insertBefore)(get(b[bStart++], 1), get(a[aStart++], -1).nextSibling);
            (0, $fGGec.insertBefore)(get(b[--bEnd], 1), node);
            // mark the future index as identical (yeah, it's dirty, but cheap 👍)
            // The main reason to do this, is that when a[aEnd] will be reached,
            // the loop will likely be on the fast path, as identical to b[bEnd].
            // In the best case scenario, the next loop will skip the tail,
            // but in the worst one, this node will be considered as already
            // processed, bailing out pretty quickly from the map index check
            a[aEnd] = b[bEnd];
        } else {
            // the map requires an O(bEnd - bStart) operation once
            // to store all future nodes indexes for later purposes.
            // In the worst case scenario, this is a full O(N) cost,
            // and such scenario happens at least when all nodes are different,
            // but also if both first and last items of the lists are different
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            // if it's a future node, hence it needs some handling
            if (map.has(a[aStart])) {
                // grab the index of such node, 'cause it might have been processed
                const index = map.get(a[aStart]);
                // if it's not already processed, look on demand for the next LCS
                if (bStart < index && index < bEnd) {
                    let i = aStart;
                    // counts the amount of nodes that are the same in the future
                    let sequence = 1;
                    while(++i < aEnd && i < bEnd && map.get(a[i]) === index + sequence)sequence++;
                    // effort decision here: if the sequence is longer than replaces
                    // needed to reach such sequence, which would brings again this loop
                    // to the fast path, prepend the difference before a sequence,
                    // and move only the future list index forward, so that aStart
                    // and bStart will be aligned again, hence on the fast path.
                    // An example considering aStart and bStart are both 0:
                    // a: [1, 2, 3, 4]
                    // b: [7, 1, 2, 3, 6]
                    // this would place 7 before 1 and, from that time on, 1, 2, and 3
                    // will be processed at zero cost
                    if (sequence > index - bStart) {
                        const node = get(a[aStart], 0);
                        while(bStart < index)(0, $fGGec.insertBefore)(get(b[bStart++], 1), node);
                    } else (0, $fGGec.replaceChild)(get(b[bStart++], 1), get(a[aStart++], -1));
                } else aStart++;
            } else (0, $fGGec.removeChild)(get(a[aStart++], -1));
        }
    }
    return b;
};
const UNMOUNT_SCOPE = Symbol('unmount');
const EachBinding = {
    // dynamic binding properties
    // childrenMap: null,
    // node: null,
    // root: null,
    // condition: null,
    // evaluate: null,
    // template: null,
    // isTemplateTag: false,
    nodes: [],
    // getKey: null,
    // indexName: null,
    // itemName: null,
    // afterPlaceholder: null,
    // placeholder: null,
    // API methods
    mount (scope, parentScope) {
        return this.update(scope, parentScope);
    },
    update (scope, parentScope) {
        const { placeholder, nodes, childrenMap } = this;
        const collection = scope === UNMOUNT_SCOPE ? null : this.evaluate(scope);
        const items = collection ? Array.from(collection) : [];
        // prepare the diffing
        const { newChildrenMap, batches, futureNodes } = createPatch(items, scope, parentScope, this);
        // patch the DOM only if there are new nodes
        udomdiff(nodes, futureNodes, patch(Array.from(childrenMap.values()), parentScope), placeholder);
        // trigger the mounts and the updates
        batches.forEach((fn)=>fn());
        // update the children map
        this.childrenMap = newChildrenMap;
        this.nodes = futureNodes;
        return this;
    },
    unmount (scope, parentScope) {
        this.update(UNMOUNT_SCOPE, parentScope);
        return this;
    }
};
/**
 * Patch the DOM while diffing
 * @param   {any[]} redundant - list of all the children (template, nodes, context) added via each
 * @param   {*} parentScope - scope of the parent template
 * @returns {Function} patch function used by domdiff
 */ function patch(redundant, parentScope) {
    return (item, info)=>{
        if (info < 0) {
            // get the last element added to the childrenMap saved previously
            const element = redundant[redundant.length - 1];
            if (element) {
                // get the nodes and the template in stored in the last child of the childrenMap
                const { template, nodes, context } = element;
                // remove the last node (notice <template> tags might have more children nodes)
                nodes.pop();
                // notice that we pass null as last argument because
                // the root node and its children will be removed by domdiff
                if (!nodes.length) {
                    // we have cleared all the children nodes and we can unmount this template
                    redundant.pop();
                    template.unmount(context, parentScope, null);
                }
            }
        }
        return item;
    };
}
/**
 * Check whether a template must be filtered from a loop
 * @param   {Function} condition - filter function
 * @param   {Object} context - argument passed to the filter function
 * @returns {boolean} true if this item should be skipped
 */ function mustFilterItem(condition, context) {
    return condition ? !condition(context) : false;
}
/**
 * Extend the scope of the looped template
 * @param   {Object} scope - current template scope
 * @param   {Object} options - options
 * @param   {string} options.itemName - key to identify the looped item in the new context
 * @param   {string} options.indexName - key to identify the index of the looped item
 * @param   {number} options.index - current index
 * @param   {*} options.item - collection item looped
 * @returns {Object} enhanced scope object
 */ function extendScope(scope, { itemName, indexName, index, item }) {
    (0, $3h6d1.defineProperty)(scope, itemName, item);
    if (indexName) (0, $3h6d1.defineProperty)(scope, indexName, index);
    return scope;
}
/**
 * Loop the current template items
 * @param   {Array} items - expression collection value
 * @param   {*} scope - template scope
 * @param   {*} parentScope - scope of the parent template
 * @param   {EachBinding} binding - each binding object instance
 * @returns {Object} data
 * @returns {Map} data.newChildrenMap - a Map containing the new children template structure
 * @returns {Array} data.batches - array containing the template lifecycle functions to trigger
 * @returns {Array} data.futureNodes - array containing the nodes we need to diff
 */ function createPatch(items, scope, parentScope, binding) {
    const { condition, template, childrenMap, itemName, getKey, indexName, root, isTemplateTag } = binding;
    const newChildrenMap = new Map();
    const batches = [];
    const futureNodes = [];
    items.forEach((item, index)=>{
        const context = extendScope(Object.create(scope), {
            itemName: itemName,
            indexName: indexName,
            index: index,
            item: item
        });
        const key = getKey ? getKey(context) : index;
        const oldItem = childrenMap.get(key);
        const nodes = [];
        if (mustFilterItem(condition, context)) return;
        const mustMount = !oldItem;
        const componentTemplate = oldItem ? oldItem.template : template.clone();
        const el = componentTemplate.el || root.cloneNode();
        const meta = isTemplateTag && mustMount ? createTemplateMeta(componentTemplate) : componentTemplate.meta;
        if (mustMount) batches.push(()=>componentTemplate.mount(el, context, parentScope, meta));
        else batches.push(()=>componentTemplate.update(context, parentScope));
        // create the collection of nodes to update or to add
        // in case of template tags we need to add all its children nodes
        if (isTemplateTag) nodes.push(...meta.children);
        else nodes.push(el);
        // delete the old item from the children map
        childrenMap.delete(key);
        futureNodes.push(...nodes);
        // update the children map
        newChildrenMap.set(key, {
            nodes: nodes,
            template: componentTemplate,
            context: context,
            index: index
        });
    });
    return {
        newChildrenMap: newChildrenMap,
        batches: batches,
        futureNodes: futureNodes
    };
}
function create$6(node, { evaluate, condition, itemName, indexName, getKey, template }) {
    const placeholder = document.createTextNode('');
    const root = node.cloneNode();
    (0, $fGGec.insertBefore)(placeholder, node);
    (0, $fGGec.removeChild)(node);
    return {
        ...EachBinding,
        childrenMap: new Map(),
        node: node,
        root: root,
        condition: condition,
        evaluate: evaluate,
        isTemplateTag: (0, $8kAdV.isTemplate)(root),
        template: template.createDOM(node),
        getKey: getKey,
        indexName: indexName,
        itemName: itemName,
        placeholder: placeholder
    };
}
/**
 * Binding responsible for the `if` directive
 */ const IfBinding = {
    // dynamic binding properties
    // node: null,
    // evaluate: null,
    // isTemplateTag: false,
    // placeholder: null,
    // template: null,
    // API methods
    mount (scope, parentScope) {
        return this.update(scope, parentScope);
    },
    update (scope, parentScope) {
        const value = !!this.evaluate(scope);
        const mustMount = !this.value && value;
        const mustUnmount = this.value && !value;
        const mount = ()=>{
            const pristine = this.node.cloneNode();
            (0, $fGGec.insertBefore)(pristine, this.placeholder);
            this.template = this.template.clone();
            this.template.mount(pristine, scope, parentScope);
        };
        switch(true){
            case mustMount:
                mount();
                break;
            case mustUnmount:
                this.unmount(scope);
                break;
            default:
                if (value) this.template.update(scope, parentScope);
        }
        this.value = value;
        return this;
    },
    unmount (scope, parentScope) {
        this.template.unmount(scope, parentScope, true);
        return this;
    }
};
function create$5(node, { evaluate, template }) {
    const placeholder = document.createTextNode('');
    (0, $fGGec.insertBefore)(placeholder, node);
    (0, $fGGec.removeChild)(node);
    return {
        ...IfBinding,
        node: node,
        evaluate: evaluate,
        placeholder: placeholder,
        template: template.createDOM(node)
    };
}
/* c8 ignore next */ const ElementProto = typeof Element === 'undefined' ? {} : Element.prototype;
const isNativeHtmlProperty = (0, $koC5P.memoize)((name)=>ElementProto.hasOwnProperty(name));
/**
 * Add all the attributes provided
 * @param   {HTMLElement} node - target node
 * @param   {Object} attributes - object containing the attributes names and values
 * @returns {undefined} sorry it's a void function :(
 */ function setAllAttributes(node, attributes) {
    Object.keys(attributes).forEach((name)=>attributeExpression({
            node: node,
            name: name
        }, attributes[name]));
}
/**
 * Remove all the attributes provided
 * @param   {HTMLElement} node - target node
 * @param   {Object} newAttributes - object containing all the new attribute names
 * @param   {Object} oldAttributes - object containing all the old attribute names
 * @returns {undefined} sorry it's a void function :(
 */ function removeAllAttributes(node, newAttributes, oldAttributes) {
    const newKeys = newAttributes ? Object.keys(newAttributes) : [];
    Object.keys(oldAttributes).filter((name)=>!newKeys.includes(name)).forEach((attribute)=>node.removeAttribute(attribute));
}
/**
 * Check whether the attribute value can be rendered
 * @param {*} value - expression value
 * @returns {boolean} true if we can render this attribute value
 */ function canRenderAttribute(value) {
    return [
        'string',
        'number',
        'boolean'
    ].includes(typeof value);
}
/**
 * Check whether the attribute should be removed
 * @param {*} value - expression value
 * @param   {boolean} isBoolean - flag to handle boolean attributes
 * @returns {boolean} boolean - true if the attribute can be removed}
 */ function shouldRemoveAttribute(value, isBoolean) {
    // boolean attributes should be removed if the value is falsy
    if (isBoolean) return !value && value !== 0;
    // otherwise we can try to render it
    return typeof value === 'undefined' || value === null;
}
/**
 * This methods handles the DOM attributes updates
 * @param   {HTMLElement} expression.node - target node
 * @param   {string} expression.name - attribute name
 * @param   {boolean} expression.isBoolean - flag to handle boolean attributes
 * @param   {*} expression.value - the old expression cached value
 * @param   {*} value - new expression value
 * @returns {undefined}
 */ function attributeExpression({ node, name, isBoolean: isBoolean$1, value: oldValue }, value) {
    // is it a spread operator? {...attributes}
    if (!name) {
        if (oldValue) // remove all the old attributes
        removeAllAttributes(node, value, oldValue);
        // is the value still truthy?
        if (value) setAllAttributes(node, value);
        return;
    }
    // store the attribute on the node to make it compatible with native custom elements
    if (!isNativeHtmlProperty(name) && ((0, $8kAdV.isBoolean)(value) || (0, $8kAdV.isObject)(value) || (0, $8kAdV.isFunction)(value))) node[name] = value;
    if (shouldRemoveAttribute(value, isBoolean$1)) node.removeAttribute(name);
    else if (canRenderAttribute(value)) node.setAttribute(name, normalizeValue(name, value, isBoolean$1));
}
/**
 * Get the value as string
 * @param   {string} name - attribute name
 * @param   {*} value - user input value
 * @param   {boolean} isBoolean - boolean attributes flag
 * @returns {string} input value as string
 */ function normalizeValue(name, value, isBoolean) {
    // be sure that expressions like selected={ true } will always be rendered as selected='selected'
    // fix https://github.com/riot/riot/issues/2975
    return value === true && isBoolean ? name : value;
}
const RE_EVENTS_PREFIX = /^on/;
const getCallbackAndOptions = (value)=>Array.isArray(value) ? value : [
        value,
        false
    ];
// see also https://medium.com/@WebReflection/dom-handleevent-a-cross-platform-standard-since-year-2000-5bf17287fd38
const EventListener = {
    handleEvent (event) {
        this[event.type](event);
    }
};
const ListenersWeakMap = new WeakMap();
const createListener = (node)=>{
    const listener = Object.create(EventListener);
    ListenersWeakMap.set(node, listener);
    return listener;
};
/**
 * Set a new event listener
 * @param   {HTMLElement} expression.node - target node
 * @param   {string} expression.name - event name
 * @param   {*} value - new expression value
 * @returns {value} the callback just received
 */ function eventExpression({ node, name }, value) {
    const normalizedEventName = name.replace(RE_EVENTS_PREFIX, '');
    const eventListener = ListenersWeakMap.get(node) || createListener(node);
    const [callback, options] = getCallbackAndOptions(value);
    const handler = eventListener[normalizedEventName];
    const mustRemoveEvent = handler && !callback;
    const mustAddEvent = callback && !handler;
    if (mustRemoveEvent) node.removeEventListener(normalizedEventName, eventListener);
    if (mustAddEvent) node.addEventListener(normalizedEventName, eventListener, options);
    eventListener[normalizedEventName] = callback;
}
/**
 * Normalize the user value in order to render a empty string in case of falsy values
 * @param   {*} value - user input value
 * @returns {string} hopefully a string
 */ function normalizeStringValue(value) {
    return (0, $8kAdV.isNil)(value) ? '' : value;
}
/**
 * Get the the target text node to update or create one from of a comment node
 * @param   {HTMLElement} node - any html element containing childNodes
 * @param   {number} childNodeIndex - index of the text node in the childNodes list
 * @returns {Text} the text node to update
 */ const getTextNode = (node, childNodeIndex)=>{
    return node.childNodes[childNodeIndex];
};
/**
 * This methods handles a simple text expression update
 * @param   {HTMLElement} expression.node - target node
 * @param   {*} value - new expression value
 * @returns {undefined}
 */ function textExpression({ node }, value) {
    node.data = normalizeStringValue(value);
}
/**
 * This methods handles the input fields value updates
 * @param   {HTMLElement} expression.node - target node
 * @param   {*} value - new expression value
 * @returns {undefined}
 */ function valueExpression({ node }, value) {
    node.value = normalizeStringValue(value);
}
/**
   This method handles the REF attribute expressions 
 * @param   {HTMLElement} expression.node - target node
 * @param   {*} expression.value - the old expression cached value
 * @param   {*} value - new expression value
 * @returns {undefined}
 */ function refExpression({ node, value: oldValue }, value) {
    // called on mount and update
    if (value) value(node);
    else oldValue(null);
}
const expressions = {
    [(0, $dNFiL.ATTRIBUTE)]: attributeExpression,
    [(0, $dNFiL.EVENT)]: eventExpression,
    [(0, $dNFiL.TEXT)]: textExpression,
    [(0, $dNFiL.VALUE)]: valueExpression,
    [(0, $dNFiL.REF)]: refExpression
};
const Expression = {
    // Static props
    // node: null,
    // value: null,
    // API methods
    /**
   * Mount the expression evaluating its initial value
   * @param   {*} scope - argument passed to the expression to evaluate its current values
   * @returns {Expression} self
   */ mount (scope) {
        // hopefully a pure function
        this.value = this.evaluate(scope);
        // IO() DOM updates
        expressions[this.type](this, this.value);
        return this;
    },
    /**
   * Update the expression if its value changed
   * @param   {*} scope - argument passed to the expression to evaluate its current values
   * @returns {Expression} self
   */ update (scope) {
        // pure function
        const value = this.evaluate(scope);
        if (this.value !== value) {
            // IO() DOM updates
            expressions[this.type](this, value);
            this.value = value;
        }
        return this;
    },
    /**
   * Expression teardown method
   * @returns {Expression} self
   */ unmount () {
        // unmount event and ref expressions
        if ([
            (0, $dNFiL.EVENT),
            (0, $dNFiL.REF)
        ].includes(this.type)) expressions[this.type](this, null);
        return this;
    }
};
function create$4(node, data) {
    return {
        ...Expression,
        ...data,
        node: data.type === (0, $dNFiL.TEXT) ? getTextNode(node, data.childNodeIndex) : node
    };
}
/**
 * Create a flat object having as keys a list of methods that if dispatched will propagate
 * on the whole collection
 * @param   {Array} collection - collection to iterate
 * @param   {Array<string>} methods - methods to execute on each item of the collection
 * @param   {*} context - context returned by the new methods created
 * @returns {Object} a new object to simplify the the nested methods dispatching
 */ function flattenCollectionMethods(collection, methods, context) {
    return methods.reduce((acc, method)=>{
        return {
            ...acc,
            [method]: (scope)=>{
                return collection.map((item)=>item[method](scope)) && context;
            }
        };
    }, {});
}
function create$3(node, { expressions }) {
    return flattenCollectionMethods(expressions.map((expression)=>create$4(node, expression)), [
        'mount',
        'update',
        'unmount'
    ]);
}
function extendParentScope(attributes, scope, parentScope) {
    if (!attributes || !attributes.length) return parentScope;
    const expressions = attributes.map((attr)=>({
            ...attr,
            value: attr.evaluate(scope)
        }));
    return Object.assign(Object.create(parentScope || null), (0, $koC5P.evaluateAttributeExpressions)(expressions));
}
// this function is only meant to fix an edge case
// https://github.com/riot/riot/issues/2842
const getRealParent = (scope, parentScope)=>scope[0, $8VupT.PARENT_KEY_SYMBOL] || parentScope;
const SlotBinding = {
    // dynamic binding properties
    // node: null,
    // name: null,
    attributes: [],
    // templateData: null,
    // template: null,
    getTemplateScope (scope, parentScope) {
        return extendParentScope(this.attributes, scope, parentScope);
    },
    // API methods
    mount (scope, parentScope) {
        const templateData = scope.slots ? scope.slots.find(({ id })=>id === this.name) : false;
        const { parentNode } = this.node;
        // if the slot did not pass any content, we will use the self slot for optional fallback content (https://github.com/riot/riot/issues/3024)
        const realParent = templateData ? getRealParent(scope, parentScope) : scope;
        this.templateData = templateData;
        // override the template property if the slot needs to be replaced
        this.template = templateData && create(templateData.html, templateData.bindings).createDOM(parentNode) || // otherwise use the optional template fallback if provided by the compiler see also https://github.com/riot/riot/issues/3014
        this.template?.clone();
        if (this.template) {
            (0, $fGGec.cleanNode)(this.node);
            this.template.mount(this.node, this.getTemplateScope(scope, realParent), realParent);
            this.template.children = Array.from(this.node.childNodes);
        }
        moveSlotInnerContent(this.node);
        (0, $fGGec.removeChild)(this.node);
        return this;
    },
    update (scope, parentScope) {
        if (this.template) {
            const realParent = this.templateData ? getRealParent(scope, parentScope) : scope;
            this.template.update(this.getTemplateScope(scope, realParent), realParent);
        }
        return this;
    },
    unmount (scope, parentScope, mustRemoveRoot) {
        if (this.template) this.template.unmount(this.getTemplateScope(scope, parentScope), null, mustRemoveRoot);
        return this;
    }
};
/**
 * Move the inner content of the slots outside of them
 * @param   {HTMLElement} slot - slot node
 * @returns {undefined} it's a void method ¯\_(ツ)_/¯
 */ function moveSlotInnerContent(slot) {
    const child = slot && slot.firstChild;
    if (!child) return;
    (0, $fGGec.insertBefore)(child, slot);
    moveSlotInnerContent(slot);
}
/**
 * Create a single slot binding
 * @param   {HTMLElement} node - slot node
 * @param   {string} name - slot id
 * @param   {AttributeExpressionData[]} attributes - slot attributes
 * @returns {Object} Slot binding object
 */ function createSlot(node, { name, attributes, template }) {
    return {
        ...SlotBinding,
        attributes: attributes,
        template: template,
        node: node,
        name: name
    };
}
/**
 * Create a new tag object if it was registered before, otherwise fallback to the simple
 * template chunk
 * @param   {Function} component - component factory function
 * @param   {Array<Object>} slots - array containing the slots markup
 * @param   {Array} attributes - dynamic attributes that will be received by the tag element
 * @returns {TagImplementation|TemplateChunk} a tag implementation or a template chunk as fallback
 */ function getTag(component, slots = [], attributes = []) {
    // if this tag was registered before we will return its implementation
    if (component) return component({
        slots: slots,
        attributes: attributes
    });
    // otherwise we return a template chunk
    return create(slotsToMarkup(slots), [
        ...slotBindings(slots),
        {
            // the attributes should be registered as binding
            // if we fallback to a normal template chunk
            expressions: attributes.map((attr)=>{
                return {
                    type: (0, $dNFiL.ATTRIBUTE),
                    ...attr
                };
            })
        }
    ]);
}
/**
 * Merge all the slots bindings into a single array
 * @param   {Array<Object>} slots - slots collection
 * @returns {Array<Bindings>} flatten bindings array
 */ function slotBindings(slots) {
    return slots.reduce((acc, { bindings })=>acc.concat(bindings), []);
}
/**
 * Merge all the slots together in a single markup string
 * @param   {Array<Object>} slots - slots collection
 * @returns {string} markup of all the slots in a single string
 */ function slotsToMarkup(slots) {
    return slots.reduce((acc, slot)=>{
        return acc + slot.html;
    }, '');
}
const TagBinding = {
    // dynamic binding properties
    // node: null,
    // evaluate: null,
    // name: null,
    // slots: null,
    // tag: null,
    // attributes: null,
    // getComponent: null,
    mount (scope) {
        return this.update(scope);
    },
    update (scope, parentScope) {
        const name = this.evaluate(scope);
        // simple update
        if (name && name === this.name) this.tag.update(scope);
        else {
            // unmount the old tag if it exists
            this.unmount(scope, parentScope, true);
            // mount the new tag
            this.name = name;
            this.tag = getTag(this.getComponent(name), this.slots, this.attributes);
            this.tag.mount(this.node, scope);
        }
        return this;
    },
    unmount (scope, parentScope, keepRootTag) {
        if (this.tag) // keep the root tag
        this.tag.unmount(keepRootTag);
        return this;
    }
};
function create$2(node, { evaluate, getComponent, slots, attributes }) {
    return {
        ...TagBinding,
        node: node,
        evaluate: evaluate,
        slots: slots,
        attributes: attributes,
        getComponent: getComponent
    };
}
const bindings = {
    [(0, $f4jRS.IF)]: create$5,
    [(0, $f4jRS.SIMPLE)]: create$3,
    [(0, $f4jRS.EACH)]: create$6,
    [(0, $f4jRS.TAG)]: create$2,
    [(0, $f4jRS.SLOT)]: createSlot
};
/**
 * Text expressions in a template tag will get childNodeIndex value normalized
 * depending on the position of the <template> tag offset
 * @param   {Expression[]} expressions - riot expressions array
 * @param   {number} textExpressionsOffset - offset of the <template> tag
 * @returns {Expression[]} expressions containing the text expressions normalized
 */ function fixTextExpressionsOffset(expressions, textExpressionsOffset) {
    return expressions.map((e)=>e.type === (0, $dNFiL.TEXT) ? {
            ...e,
            childNodeIndex: e.childNodeIndex + textExpressionsOffset
        } : e);
}
/**
 * Bind a new expression object to a DOM node
 * @param   {HTMLElement} root - DOM node where to bind the expression
 * @param   {TagBindingData} binding - binding data
 * @param   {number|null} templateTagOffset - if it's defined we need to fix the text expressions childNodeIndex offset
 * @returns {Binding} Binding object
 */ function create$1(root, binding, templateTagOffset) {
    const { selector, type, redundantAttribute, expressions } = binding;
    // find the node to apply the bindings
    const node = selector ? root.querySelector(selector) : root;
    // remove eventually additional attributes created only to select this node
    if (redundantAttribute) node.removeAttribute(redundantAttribute);
    const bindingExpressions = expressions || [];
    // init the binding
    return (bindings[type] || bindings[0, $f4jRS.SIMPLE])(node, {
        ...binding,
        expressions: templateTagOffset && !selector ? fixTextExpressionsOffset(bindingExpressions, templateTagOffset) : bindingExpressions
    });
}
// in this case a simple innerHTML is enough
function createHTMLTree(html, root) {
    const template = (0, $8kAdV.isTemplate)(root) ? root : document.createElement('template');
    template.innerHTML = html;
    return template.content;
}
// for svg nodes we need a bit more work
/* c8 ignore start */ function createSVGTree(html, container) {
    // create the SVGNode
    const svgNode = container.ownerDocument.importNode(new window.DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg">${html}</svg>`, 'application/xml').documentElement, true);
    return svgNode;
}
/* c8 ignore end */ /**
 * Create the DOM that will be injected
 * @param {Object} root - DOM node to find out the context where the fragment will be created
 * @param   {string} html - DOM to create as string
 * @returns {HTMLDocumentFragment|HTMLElement} a new html fragment
 */ function createDOMTree(root, html) {
    /* c8 ignore next */ if ((0, $8kAdV.isSvg)(root)) return createSVGTree(html, root);
    return createHTMLTree(html, root);
}
/**
 * Inject the DOM tree into a target node
 * @param   {HTMLElement} el - target element
 * @param   {DocumentFragment|SVGElement} dom - dom tree to inject
 * @returns {undefined}
 */ function injectDOM(el, dom) {
    switch(true){
        case (0, $8kAdV.isSvg)(el):
            (0, $fGGec.moveChildren)(dom, el);
            break;
        case (0, $8kAdV.isTemplate)(el):
            el.parentNode.replaceChild(dom, el);
            break;
        default:
            el.appendChild(dom);
    }
}
/**
 * Create the Template DOM skeleton
 * @param   {HTMLElement} el - root node where the DOM will be injected
 * @param   {string|HTMLElement} html - HTML markup or HTMLElement that will be injected into the root node
 * @returns {?DocumentFragment} fragment that will be injected into the root node
 */ function createTemplateDOM(el, html) {
    return html && (typeof html === 'string' ? createDOMTree(el, html) : html);
}
/**
 * Get the offset of the <template> tag
 * @param {HTMLElement} parentNode - template tag parent node
 * @param {HTMLElement} el - the template tag we want to render
 * @param   {Object} meta - meta properties needed to handle the <template> tags in loops
 * @returns {number} offset of the <template> tag calculated from its siblings DOM nodes
 */ function getTemplateTagOffset(parentNode, el, meta) {
    const siblings = Array.from(parentNode.childNodes);
    return Math.max(siblings.indexOf(el), siblings.indexOf(meta.head) + 1, 0);
}
/**
 * Template Chunk model
 * @type {Object}
 */ const TemplateChunk = {
    // Static props
    // bindings: null,
    // bindingsData: null,
    // html: null,
    // isTemplateTag: false,
    // fragment: null,
    // children: null,
    // dom: null,
    // el: null,
    /**
   * Create the template DOM structure that will be cloned on each mount
   * @param   {HTMLElement} el - the root node
   * @returns {TemplateChunk} self
   */ createDOM (el) {
        // make sure that the DOM gets created before cloning the template
        this.dom = this.dom || createTemplateDOM(el, this.html) || document.createDocumentFragment();
        return this;
    },
    // API methods
    /**
   * Attach the template to a DOM node
   * @param   {HTMLElement} el - target DOM node
   * @param   {*} scope - template data
   * @param   {*} parentScope - scope of the parent template tag
   * @param   {Object} meta - meta properties needed to handle the <template> tags in loops
   * @returns {TemplateChunk} self
   */ mount (el, scope, parentScope, meta = {}) {
        if (!el) (0, $koC5P.panic)('Please provide DOM node to mount properly your template');
        if (this.el) this.unmount(scope);
        // <template> tags require a bit more work
        // the template fragment might be already created via meta outside of this call
        const { fragment, children, avoidDOMInjection } = meta;
        // <template> bindings of course can not have a root element
        // so we check the parent node to set the query selector bindings
        const { parentNode } = children ? children[0] : el;
        const isTemplateTag = (0, $8kAdV.isTemplate)(el);
        const templateTagOffset = isTemplateTag ? getTemplateTagOffset(parentNode, el, meta) : null;
        // create the DOM if it wasn't created before
        this.createDOM(el);
        // create the DOM of this template cloning the original DOM structure stored in this instance
        // notice that if a documentFragment was passed (via meta) we will use it instead
        const cloneNode = fragment || this.dom.cloneNode(true);
        // store root node
        // notice that for template tags the root note will be the parent tag
        this.el = isTemplateTag ? parentNode : el;
        // create the children array only for the <template> fragments
        this.children = isTemplateTag ? children || Array.from(cloneNode.childNodes) : null;
        // inject the DOM into the el only if a fragment is available
        if (!avoidDOMInjection && cloneNode) injectDOM(el, cloneNode);
        // create the bindings
        this.bindings = this.bindingsData.map((binding)=>create$1(this.el, binding, templateTagOffset));
        this.bindings.forEach((b)=>b.mount(scope, parentScope));
        // store the template meta properties
        this.meta = meta;
        return this;
    },
    /**
   * Update the template with fresh data
   * @param   {*} scope - template data
   * @param   {*} parentScope - scope of the parent template tag
   * @returns {TemplateChunk} self
   */ update (scope, parentScope) {
        this.bindings.forEach((b)=>b.update(scope, parentScope));
        return this;
    },
    /**
   * Remove the template from the node where it was initially mounted
   * @param   {*} scope - template data
   * @param   {*} parentScope - scope of the parent template tag
   * @param   {boolean|null} mustRemoveRoot - if true remove the root element,
   * if false or undefined clean the root tag content, if null don't touch the DOM
   * @returns {TemplateChunk} self
   */ unmount (scope, parentScope, mustRemoveRoot = false) {
        const el = this.el;
        if (!el) return this;
        this.bindings.forEach((b)=>b.unmount(scope, parentScope, mustRemoveRoot));
        switch(true){
            // pure components should handle the DOM unmount updates by themselves
            // for mustRemoveRoot === null don't touch the DOM
            case el[0, $8VupT.IS_PURE_SYMBOL] || mustRemoveRoot === null:
                break;
            // if children are declared, clear them
            // applicable for <template> and <slot/> bindings
            case Array.isArray(this.children):
                (0, $fGGec.clearChildren)(this.children);
                break;
            // clean the node children only
            case !mustRemoveRoot:
                (0, $fGGec.cleanNode)(el);
                break;
            // remove the root node only if the mustRemoveRoot is truly
            case !!mustRemoveRoot:
                (0, $fGGec.removeChild)(el);
                break;
        }
        this.el = null;
        return this;
    },
    /**
   * Clone the template chunk
   * @returns {TemplateChunk} a clone of this object resetting the this.el property
   */ clone () {
        return {
            ...this,
            meta: {},
            el: null
        };
    }
};
/**
 * Create a template chunk wiring also the bindings
 * @param   {string|HTMLElement} html - template string
 * @param   {BindingData[]} bindings - bindings collection
 * @returns {TemplateChunk} a new TemplateChunk copy
 */ function create(html, bindings = []) {
    return {
        ...TemplateChunk,
        html: html,
        bindingsData: bindings
    };
}

});
parcelRegister("fGGec", function(module, exports) {

$parcel$export(module.exports, "DOMattributesToObject", () => $b6bb88d9fb552988$export$f5c4414827140849);
$parcel$export(module.exports, "moveChildren", () => $b6bb88d9fb552988$export$434b8be66f8c2ac9);
$parcel$export(module.exports, "cleanNode", () => $b6bb88d9fb552988$export$9497debfa326231a);
$parcel$export(module.exports, "clearChildren", () => $b6bb88d9fb552988$export$da51b626bd37c807);
$parcel$export(module.exports, "removeChild", () => $b6bb88d9fb552988$export$7ae609f7af59e4f7);
$parcel$export(module.exports, "insertBefore", () => $b6bb88d9fb552988$export$86b68c7dbeb53c22);
$parcel$export(module.exports, "replaceChild", () => $b6bb88d9fb552988$export$46f78da0e790aab7);
/* Riot WIP, @license MIT */ 
var $ldAW2 = parcelRequire("ldAW2");
/**
 * Get all the element attributes as object
 * @param   {HTMLElement} element - DOM node we want to parse
 * @returns {Object} all the attributes found as a key value pairs
 */ function $b6bb88d9fb552988$export$f5c4414827140849(element) {
    return Array.from(element.attributes).reduce((acc, attribute)=>{
        acc[(0, $ldAW2.dashToCamelCase)(attribute.name)] = attribute.value;
        return acc;
    }, {});
}
/**
 * Move all the child nodes from a source tag to another
 * @param   {HTMLElement} source - source node
 * @param   {HTMLElement} target - target node
 * @returns {undefined} it's a void method ¯\_(ツ)_/¯
 */ // Ignore this helper because it's needed only for svg tags
function $b6bb88d9fb552988$export$434b8be66f8c2ac9(source, target) {
    // eslint-disable-next-line fp/no-loops
    while(source.firstChild)target.appendChild(source.firstChild);
}
/**
 * Remove the child nodes from any DOM node
 * @param   {HTMLElement} node - target node
 * @returns {undefined}
 */ function $b6bb88d9fb552988$export$9497debfa326231a(node) {
    // eslint-disable-next-line fp/no-loops
    while(node.firstChild)node.removeChild(node.firstChild);
}
/**
 * Clear multiple children in a node
 * @param   {HTMLElement[]} children - direct children nodes
 * @returns {undefined}
 */ function $b6bb88d9fb552988$export$da51b626bd37c807(children) {
    // eslint-disable-next-line fp/no-loops,fp/no-let
    for(let i = 0; i < children.length; i++)$b6bb88d9fb552988$export$7ae609f7af59e4f7(children[i]);
}
/**
 * Remove a node
 * @param {HTMLElement}node - node to remove
 * @returns {undefined}
 */ const $b6bb88d9fb552988$export$7ae609f7af59e4f7 = (node)=>node.remove();
/**
 * Insert before a node
 * @param {HTMLElement} newNode - node to insert
 * @param {HTMLElement} refNode - ref child
 * @returns {undefined}
 */ const $b6bb88d9fb552988$export$86b68c7dbeb53c22 = (newNode, refNode)=>refNode && refNode.parentNode && refNode.parentNode.insertBefore(newNode, refNode);
/**
 * Replace a node
 * @param {HTMLElement} newNode - new node to add to the DOM
 * @param {HTMLElement} replaced - node to replace
 * @returns {undefined}
 */ const $b6bb88d9fb552988$export$46f78da0e790aab7 = (newNode, replaced)=>replaced && replaced.parentNode && replaced.parentNode.replaceChild(newNode, replaced);

});
parcelRegister("ldAW2", function(module, exports) {

$parcel$export(module.exports, "camelToDashCase", () => $f7277666e0936a5c$export$6e116da553d9a4d8);
$parcel$export(module.exports, "dashToCamelCase", () => $f7277666e0936a5c$export$138f9917dd6248b4);
/* Riot WIP, @license MIT */ /**
 * Convert a string from camel case to dash-case
 * @param   {string} string - probably a component tag name
 * @returns {string} component name normalized
 */ function $f7277666e0936a5c$export$6e116da553d9a4d8(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
/**
 * Convert a string containing dashes to camel case
 * @param   {string} string - input string
 * @returns {string} my-string -> myString
 */ function $f7277666e0936a5c$export$138f9917dd6248b4(string) {
    return string.replace(/-(\w)/g, (_, c)=>c.toUpperCase());
}

});


parcelRegister("8VupT", function(module, exports) {

$parcel$export(module.exports, "COMPONENTS_IMPLEMENTATION_MAP", () => $67fb3db5a3808819$export$7fb861b8a16b2c5e);
$parcel$export(module.exports, "DOM_COMPONENT_INSTANCE_PROPERTY", () => $67fb3db5a3808819$export$e681ba2bbc520092);
$parcel$export(module.exports, "PLUGINS_SET", () => $67fb3db5a3808819$export$b50a8212494d152);
$parcel$export(module.exports, "IS_DIRECTIVE", () => $67fb3db5a3808819$export$f6c8a57c22bed1ce);
$parcel$export(module.exports, "MOUNT_METHOD_KEY", () => $67fb3db5a3808819$export$5168d697e02447c0);
$parcel$export(module.exports, "UPDATE_METHOD_KEY", () => $67fb3db5a3808819$export$631a8600c6d6a92f);
$parcel$export(module.exports, "UNMOUNT_METHOD_KEY", () => $67fb3db5a3808819$export$ca8982e815a3faee);
$parcel$export(module.exports, "SHOULD_UPDATE_KEY", () => $67fb3db5a3808819$export$44b81687b13278e5);
$parcel$export(module.exports, "ON_BEFORE_MOUNT_KEY", () => $67fb3db5a3808819$export$d56fbe519e06c7b5);
$parcel$export(module.exports, "ON_MOUNTED_KEY", () => $67fb3db5a3808819$export$38c5193d35c2c953);
$parcel$export(module.exports, "ON_BEFORE_UPDATE_KEY", () => $67fb3db5a3808819$export$c64b6b434b66725f);
$parcel$export(module.exports, "ON_UPDATED_KEY", () => $67fb3db5a3808819$export$8b7376a033703125);
$parcel$export(module.exports, "ON_BEFORE_UNMOUNT_KEY", () => $67fb3db5a3808819$export$f4ca6732670723ac);
$parcel$export(module.exports, "ON_UNMOUNTED_KEY", () => $67fb3db5a3808819$export$d8611e9dbf9f1e4f);
$parcel$export(module.exports, "PROPS_KEY", () => $67fb3db5a3808819$export$bfbebb51095821d3);
$parcel$export(module.exports, "STATE_KEY", () => $67fb3db5a3808819$export$b56c47f66926ce06);
$parcel$export(module.exports, "SLOTS_KEY", () => $67fb3db5a3808819$export$9982265a62cce53e);
$parcel$export(module.exports, "ROOT_KEY", () => $67fb3db5a3808819$export$b4861ce6ec7db8f3);
$parcel$export(module.exports, "IS_PURE_SYMBOL", () => $67fb3db5a3808819$export$4857469bdae0a7f8);
$parcel$export(module.exports, "IS_COMPONENT_UPDATING", () => $67fb3db5a3808819$export$32deca042718281d);
$parcel$export(module.exports, "PARENT_KEY_SYMBOL", () => $67fb3db5a3808819$export$6615e4dd2821a46e);
$parcel$export(module.exports, "ATTRIBUTES_KEY_SYMBOL", () => $67fb3db5a3808819$export$bdaeca44250b1a18);
$parcel$export(module.exports, "TEMPLATE_KEY_SYMBOL", () => $67fb3db5a3808819$export$f201cab4277a5134);
/* Riot WIP, @license MIT */ // Riot.js constants that can be used across more modules
const $67fb3db5a3808819$export$7fb861b8a16b2c5e = new Map(), $67fb3db5a3808819$export$e681ba2bbc520092 = Symbol('riot-component'), $67fb3db5a3808819$export$b50a8212494d152 = new Set(), $67fb3db5a3808819$export$f6c8a57c22bed1ce = 'is', $67fb3db5a3808819$export$5168d697e02447c0 = 'mount', $67fb3db5a3808819$export$631a8600c6d6a92f = 'update', $67fb3db5a3808819$export$ca8982e815a3faee = 'unmount', $67fb3db5a3808819$export$44b81687b13278e5 = 'shouldUpdate', $67fb3db5a3808819$export$d56fbe519e06c7b5 = 'onBeforeMount', $67fb3db5a3808819$export$38c5193d35c2c953 = 'onMounted', $67fb3db5a3808819$export$c64b6b434b66725f = 'onBeforeUpdate', $67fb3db5a3808819$export$8b7376a033703125 = 'onUpdated', $67fb3db5a3808819$export$f4ca6732670723ac = 'onBeforeUnmount', $67fb3db5a3808819$export$d8611e9dbf9f1e4f = 'onUnmounted', $67fb3db5a3808819$export$bfbebb51095821d3 = 'props', $67fb3db5a3808819$export$b56c47f66926ce06 = 'state', $67fb3db5a3808819$export$9982265a62cce53e = 'slots', $67fb3db5a3808819$export$b4861ce6ec7db8f3 = 'root', $67fb3db5a3808819$export$4857469bdae0a7f8 = Symbol('pure'), $67fb3db5a3808819$export$32deca042718281d = Symbol('is_updating'), $67fb3db5a3808819$export$6615e4dd2821a46e = Symbol('parent'), $67fb3db5a3808819$export$bdaeca44250b1a18 = Symbol('attributes'), $67fb3db5a3808819$export$f201cab4277a5134 = Symbol('template');

});

parcelRegister("f4jRS", function(module, exports) {

$parcel$export(module.exports, "EACH", () => $af86a41686848fd6$export$1f15bedf49e15e92);
$parcel$export(module.exports, "IF", () => $af86a41686848fd6$export$5749f35ae68e5477);
$parcel$export(module.exports, "SIMPLE", () => $af86a41686848fd6$export$aca095bc476d426f);
$parcel$export(module.exports, "TAG", () => $af86a41686848fd6$export$2680f340d0781853);
$parcel$export(module.exports, "SLOT", () => $af86a41686848fd6$export$4dc770bbadfb72db);
$parcel$export(module.exports, "default", () => $af86a41686848fd6$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ const $af86a41686848fd6$export$1f15bedf49e15e92 = 0;
const $af86a41686848fd6$export$5749f35ae68e5477 = 1;
const $af86a41686848fd6$export$aca095bc476d426f = 2;
const $af86a41686848fd6$export$2680f340d0781853 = 3;
const $af86a41686848fd6$export$4dc770bbadfb72db = 4;
const $af86a41686848fd6$export$2e2bcd8739ae039 = {
    EACH: $af86a41686848fd6$export$1f15bedf49e15e92,
    IF: $af86a41686848fd6$export$5749f35ae68e5477,
    SIMPLE: $af86a41686848fd6$export$aca095bc476d426f,
    TAG: $af86a41686848fd6$export$2680f340d0781853,
    SLOT: $af86a41686848fd6$export$4dc770bbadfb72db
};

});

parcelRegister("dNFiL", function(module, exports) {

$parcel$export(module.exports, "ATTRIBUTE", () => $a0bfe3a2f5ce6bb1$export$77a31abf1489fff);
$parcel$export(module.exports, "EVENT", () => $a0bfe3a2f5ce6bb1$export$e39a34cfd532e15);
$parcel$export(module.exports, "TEXT", () => $a0bfe3a2f5ce6bb1$export$d597759d33be802e);
$parcel$export(module.exports, "VALUE", () => $a0bfe3a2f5ce6bb1$export$764bd63f4c2043a2);
$parcel$export(module.exports, "REF", () => $a0bfe3a2f5ce6bb1$export$19039a9c5d174551);
$parcel$export(module.exports, "default", () => $a0bfe3a2f5ce6bb1$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ const $a0bfe3a2f5ce6bb1$export$77a31abf1489fff = 0;
const $a0bfe3a2f5ce6bb1$export$e39a34cfd532e15 = 1;
const $a0bfe3a2f5ce6bb1$export$d597759d33be802e = 2;
const $a0bfe3a2f5ce6bb1$export$764bd63f4c2043a2 = 3;
const $a0bfe3a2f5ce6bb1$export$19039a9c5d174551 = 4;
const $a0bfe3a2f5ce6bb1$export$2e2bcd8739ae039 = {
    ATTRIBUTE: $a0bfe3a2f5ce6bb1$export$77a31abf1489fff,
    EVENT: $a0bfe3a2f5ce6bb1$export$e39a34cfd532e15,
    TEXT: $a0bfe3a2f5ce6bb1$export$d597759d33be802e,
    VALUE: $a0bfe3a2f5ce6bb1$export$764bd63f4c2043a2,
    REF: $a0bfe3a2f5ce6bb1$export$19039a9c5d174551
};

});

parcelRegister("3h6d1", function(module, exports) {

$parcel$export(module.exports, "defineProperty", () => $2627c697786f4493$export$fdab3c20aae16ddf);
$parcel$export(module.exports, "defineProperties", () => $2627c697786f4493$export$b61bda4fbca264f2);
$parcel$export(module.exports, "defineDefaults", () => $2627c697786f4493$export$60c9243e6eb9abf8);
$parcel$export(module.exports, "pick", () => $2627c697786f4493$export$357523c63a2253b9);
/* Riot WIP, @license MIT */ 
var $8kAdV = parcelRequire("8kAdV");
/**
 * Helper function to set an immutable property
 * @param   {Object} source - object where the new property will be set
 * @param   {string} key - object key where the new property will be stored
 * @param   {*} value - value of the new property
 * @param   {Object} options - set the property overriding the default options
 * @returns {Object} - the original object modified
 */ function $2627c697786f4493$export$fdab3c20aae16ddf(source, key, value, options = {}) {
    /* eslint-disable fp/no-mutating-methods */ Object.defineProperty(source, key, {
        value: value,
        enumerable: false,
        writable: false,
        configurable: true,
        ...options
    });
    /* eslint-enable fp/no-mutating-methods */ return source;
}
/**
 * Define multiple properties on a target object
 * @param   {Object} source - object where the new properties will be set
 * @param   {Object} properties - object containing as key pair the key + value properties
 * @param   {Object} options - set the property overriding the default options
 * @returns {Object} the original object modified
 */ function $2627c697786f4493$export$b61bda4fbca264f2(source, properties, options) {
    Object.entries(properties).forEach(([key, value])=>{
        $2627c697786f4493$export$fdab3c20aae16ddf(source, key, value, options);
    });
    return source;
}
/**
 * Define default properties if they don't exist on the source object
 * @param   {Object} source - object that will receive the default properties
 * @param   {Object} defaults - object containing additional optional keys
 * @returns {Object} the original object received enhanced
 */ function $2627c697786f4493$export$60c9243e6eb9abf8(source, defaults) {
    Object.entries(defaults).forEach(([key, value])=>{
        if (!source[key]) source[key] = value;
    });
    return source;
}
/**
 * Generate a new object picking only the properties from a given array
 * @param {Object} source - target object
 * @param {Array} keys - list of keys that we want to copy over to the new object
 * @return {Object} a new object conaining only the keys that we have picked from the keys array list
 */ function $2627c697786f4493$export$357523c63a2253b9(source, keys) {
    return (0, $8kAdV.isObject)(source) ? Object.fromEntries(keys.map((key)=>[
            key,
            source[key]
        ])) : source;
}

});
parcelRegister("8kAdV", function(module, exports) {

$parcel$export(module.exports, "isSvg", () => $610c4a388926c3ae$export$d6c18d944d9c6dc7);
$parcel$export(module.exports, "isTemplate", () => $610c4a388926c3ae$export$6306e0d85c68df69);
$parcel$export(module.exports, "isFunction", () => $610c4a388926c3ae$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBoolean", () => $610c4a388926c3ae$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isObject", () => $610c4a388926c3ae$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isNil", () => $610c4a388926c3ae$export$984f70f9382f5d27);
/* Riot WIP, @license MIT */ /**
 * Quick type checking
 * @param   {*} element - anything
 * @param   {string} type - type definition
 * @returns {boolean} true if the type corresponds
 */ function $610c4a388926c3ae$export$3ef26b6206bb4811(element, type) {
    return typeof element === type;
}
/**
 * Check if an element is part of an svg
 * @param   {HTMLElement}  el - element to check
 * @returns {boolean} true if we are in an svg context
 */ function $610c4a388926c3ae$export$d6c18d944d9c6dc7(el) {
    const owner = el.ownerSVGElement;
    return !!owner || owner === null;
}
/**
 * Check if an element is a template tag
 * @param   {HTMLElement}  el - element to check
 * @returns {boolean} true if it's a <template>
 */ function $610c4a388926c3ae$export$6306e0d85c68df69(el) {
    return el.tagName.toLowerCase() === 'template';
}
/**
 * Check that will be passed if its argument is a function
 * @param   {*} value - value to check
 * @returns {boolean} - true if the value is a function
 */ function $610c4a388926c3ae$export$f6e2535fb5126e54(value) {
    return $610c4a388926c3ae$export$3ef26b6206bb4811(value, 'function');
}
/**
 * Check if a value is a Boolean
 * @param   {*}  value - anything
 * @returns {boolean} true only for the value is a boolean
 */ function $610c4a388926c3ae$export$f9ce7b637dfbe238(value) {
    return $610c4a388926c3ae$export$3ef26b6206bb4811(value, 'boolean');
}
/**
 * Check if a value is an Object
 * @param   {*}  value - anything
 * @returns {boolean} true only for the value is an object
 */ function $610c4a388926c3ae$export$a6cdc56e425d0d0a(value) {
    return !$610c4a388926c3ae$export$984f70f9382f5d27(value) && value.constructor === Object;
}
/**
 * Check if a value is null or undefined
 * @param   {*}  value - anything
 * @returns {boolean} true only for the 'undefined' and 'null' types
 */ function $610c4a388926c3ae$export$984f70f9382f5d27(value) {
    return value === null || value === undefined;
}
/**
 * Detect node js environment
 * @returns {boolean} true if the runtime is node
 */ function $610c4a388926c3ae$export$8ee0fc9ee280b4ee() {
    return typeof globalThis.process !== 'undefined';
}

});


parcelRegister("koC5P", function(module, exports) {

$parcel$export(module.exports, "panic", () => $ed93990181680b27$export$73d91aecc00f5458);
$parcel$export(module.exports, "memoize", () => $ed93990181680b27$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "evaluateAttributeExpressions", () => $ed93990181680b27$export$65ef383c5ae02cc4);
/* Riot WIP, @license MIT */ 
var $dNFiL = parcelRequire("dNFiL");

var $ldAW2 = parcelRequire("ldAW2");
/**
 * Throw an error with a descriptive message
 * @param   { string } message - error message
 * @param   { string } cause - optional error cause object
 * @returns { undefined } hoppla... at this point the program should stop working
 */ function $ed93990181680b27$export$73d91aecc00f5458(message, cause) {
    throw new Error(message, {
        cause: cause
    });
}
/**
 * Returns the memoized (cached) function.
 * // borrowed from https://www.30secondsofcode.org/js/s/memoize
 * @param {Function} fn - function to memoize
 * @returns {Function} memoize function
 */ function $ed93990181680b27$export$fc10aeed3a532e2a(fn) {
    const cache = new Map();
    const cached = (val)=>{
        return cache.has(val) ? cache.get(val) : cache.set(val, fn.call(this, val)) && cache.get(val);
    };
    cached.cache = cache;
    return cached;
}
/**
 * Evaluate a list of attribute expressions
 * @param   {Array} attributes - attribute expressions generated by the riot compiler
 * @returns {Object} key value pairs with the result of the computation
 */ function $ed93990181680b27$export$65ef383c5ae02cc4(attributes) {
    return attributes.reduce((acc, attribute)=>{
        const { value: value, type: type } = attribute;
        switch(true){
            // spread attribute
            case !attribute.name && type === (0, $dNFiL.ATTRIBUTE):
                return {
                    ...acc,
                    ...value
                };
            // value attribute
            case type === (0, $dNFiL.VALUE):
                acc.value = attribute.value;
                break;
            // normal attributes
            default:
                acc[(0, $ldAW2.dashToCamelCase)(attribute.name)] = attribute.value;
        }
        return acc;
    }, {});
}

});


parcelRegister("av5wi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5114c5e86d01b1$export$2e2bcd8739ae039);

var $84N1j = parcelRequire("84N1j");
var $jR26U = parcelRequire("jR26U");

var $507si = parcelRequire("507si");
// this object will contain all the components implementations lazy loaded
const $7a5114c5e86d01b1$var$cache = new WeakMap();
// expose the cache as static property
$7a5114c5e86d01b1$export$2e2bcd8739ae039.cache = $7a5114c5e86d01b1$var$cache;
// static attribute in case we want to just export a lazy riot component
$7a5114c5e86d01b1$export$2e2bcd8739ae039.export = function lazyExport(Loader, Component) {
    // it could be that the user don't want to use a loader for whatever reason
    const hasLoader = Loader && Component;
    const LazyComponent = hasLoader ? Component : Loader;
    const load = ()=>typeof LazyComponent === 'function' ? LazyComponent() : Promise.resolve(LazyComponent);
    const cachedComponent = $7a5114c5e86d01b1$var$cache.get(LazyComponent);
    return (0, $jR26U.pure)(({ slots: slots, attributes: attributes, props: props })=>({
            mount (el, parentScope) {
                this.el = el;
                this.isMounted = true;
                const mount = ()=>{
                    this.mountLazyComponent(parentScope);
                    this.el.dispatchEvent(new Event('load'));
                };
                if (cachedComponent) mount();
                else {
                    if (hasLoader) this.createManagedComponent(Loader, parentScope);
                    load().then((data)=>{
                        $7a5114c5e86d01b1$var$cache.set(LazyComponent, data.default || data);
                        mount();
                    });
                }
            },
            createManagedComponent (Child, parentScope) {
                this.component = (0, $84N1j.component)(Child)(this.el, props, {
                    attributes: attributes,
                    slots: slots,
                    parentScope: parentScope
                });
            },
            mountLazyComponent (parentScope) {
                // if this component was unmounted just return here
                if (!this.isMounted) return;
                // unmount the loader if it was previously created
                if (this.component) {
                    // unmount the bindings (keeping the root node)
                    this.component.unmount(true);
                    // clean the DOM
                    if (this.el.children.length) (0, $507si.cleanNode)(this.el);
                }
                // replace the old component instance with the new lazy loaded component
                this.createManagedComponent($7a5114c5e86d01b1$var$cache.get(LazyComponent), parentScope);
            },
            update (parentScope) {
                if (this.isMounted && this.component) this.component.update({}, parentScope);
            },
            unmount (...args) {
                this.isMounted = false;
                if (this.component) this.component.unmount(...args);
            }
        }));
};
function $7a5114c5e86d01b1$export$2e2bcd8739ae039(Loader, Component) {
    return {
        name: 'lazy',
        exports: $7a5114c5e86d01b1$export$2e2bcd8739ae039.export(Loader, Component)
    };
}

});
parcelRegister("84N1j", function(module, exports) {

$parcel$export(module.exports, "component", () => $5e14b8d5841bdab5$export$d8556a2a8f973135);
/* Riot v9.4.6, @license MIT */ 
var $aC6LT = parcelRequire("aC6LT");

var $2J5Du = parcelRequire("2J5Du");
/**
 * Helper method to create component without relying on the registered ones
 * @param   {Object} implementation - component implementation
 * @returns {Function} function that will allow you to mount a riot component on a DOM node
 */ function $5e14b8d5841bdab5$export$d8556a2a8f973135(implementation) {
    return (el, props, { slots: slots, attributes: attributes, parentScope: parentScope } = {})=>(0, $aC6LT.default)((c)=>c.mount(el, parentScope), (c)=>c({
                props: props,
                slots: slots,
                attributes: attributes
            }), (0, $2J5Du.createComponentFromWrapper))(implementation);
}

});
parcelRegister("aC6LT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba2b4a53f68798a$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ /**
 * Similar to compose but performs from left-to-right function composition.<br/>
 * {@link https://30secondsofcode.org/function#composeright see also}
 * @param   {...[function]} fns) - list of unary function
 * @returns {*} result of the computation
 */ /**
 * Performs right-to-left function composition.<br/>
 * Use Array.prototype.reduce() to perform right-to-left function composition.<br/>
 * The last (rightmost) function can accept one or more arguments; the remaining functions must be unary.<br/>
 * {@link https://30secondsofcode.org/function#compose original source code}
 * @param   {...[function]} fns) - list of unary function
 * @returns {*} result of the computation
 */ function $7ba2b4a53f68798a$export$2e2bcd8739ae039(...fns) {
    return fns.reduce((f, g)=>(...args)=>f(g(...args)));
}

});

parcelRegister("2J5Du", function(module, exports) {

$parcel$export(module.exports, "createComponentFromWrapper", () => $1fc427e8fe077837$export$947ce802869248c7);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $ldAW2 = parcelRequire("ldAW2");

var $fXyIK = parcelRequire("fXyIK");

var $koC5P = parcelRequire("koC5P");

var $aem2Q = parcelRequire("aem2Q");

var $diRSU = parcelRequire("diRSU");

var $cChHS = parcelRequire("cChHS");

var $7G6OA = parcelRequire("7G6OA");
/**
 * Create the subcomponents that can be included inside a tag in runtime
 * @param   {Object} components - components imported in runtime
 * @returns {Object} all the components transformed into Riot.Component factory functions
 */ function $1fc427e8fe077837$var$createChildrenComponentsObject(components = {}) {
    return Object.entries((0, $fXyIK.callOrAssign)(components)).reduce((acc, [key, value])=>{
        acc[(0, $ldAW2.camelToDashCase)(key)] = $1fc427e8fe077837$export$947ce802869248c7(value);
        return acc;
    }, {});
}
/**
 * Create the getter function to render the child components
 * @param   {RiotComponentWrapper} componentWrapper - riot compiler generated object
 * @returns {Function} function returning the component factory function
 */ const $1fc427e8fe077837$var$createChildComponentGetter = (componentWrapper)=>{
    const childrenComponents = $1fc427e8fe077837$var$createChildrenComponentsObject(componentWrapper.exports ? componentWrapper.exports.components : {});
    return (name)=>{
        // improve support for recursive components
        if (name === componentWrapper.name) return $1fc427e8fe077837$var$memoizedCreateComponentFromWrapper(componentWrapper);
        // return the registered components
        return childrenComponents[name] || (0, $8VupT.COMPONENTS_IMPLEMENTATION_MAP).get(name);
    };
};
/**
 * Performance optimization for the recursive components
 * @param  {RiotComponentWrapper} componentWrapper - riot compiler generated object
 * @returns {Object} component like interface
 */ const $1fc427e8fe077837$var$memoizedCreateComponentFromWrapper = (0, $koC5P.memoize)($1fc427e8fe077837$export$947ce802869248c7);
/**
 * Create the component interface needed for the @riotjs/dom-bindings tag bindings
 * @param   {RiotComponentWrapper} componentWrapper - riot compiler generated object
 * @param   {string} componentWrapper.css - component css
 * @param   {Function} componentWrapper.template - function that will return the dom-bindings template function
 * @param   {Object} componentWrapper.exports - component interface
 * @param   {string} componentWrapper.name - component name
 * @returns {Object} component like interface
 */ function $1fc427e8fe077837$export$947ce802869248c7(componentWrapper) {
    const { css: css, template: template, exports: exports, name: name } = componentWrapper;
    const templateFn = template ? (0, $diRSU.componentTemplateFactory)(template, componentWrapper, $1fc427e8fe077837$var$createChildComponentGetter(componentWrapper)) : (0, $aem2Q.MOCKED_TEMPLATE_INTERFACE);
    return ({ slots: slots, attributes: attributes, props: props })=>{
        // pure components rendering will be managed by the end user
        if (exports && exports[0, $8VupT.IS_PURE_SYMBOL]) return (0, $cChHS.createPureComponent)(exports, {
            slots: slots,
            attributes: attributes,
            props: props,
            css: css,
            template: template
        });
        const componentAPI = (0, $fXyIK.callOrAssign)(exports) || {};
        const component = (0, $7G6OA.instantiateComponent)({
            css: css,
            template: templateFn,
            componentAPI: componentAPI,
            name: name
        })({
            slots: slots,
            attributes: attributes,
            props: props
        });
        // notice that for the components created via tag binding
        // we need to invert the mount (state/parentScope) arguments
        // the template bindings will only forward the parentScope updates
        // and never deal with the component state
        return {
            mount (element, parentScope, state) {
                return component.mount(element, state, parentScope);
            },
            update (parentScope, state) {
                return component.update(state, parentScope);
            },
            unmount (preserveRoot) {
                return component.unmount(preserveRoot);
            }
        };
    };
}

});
parcelRegister("fXyIK", function(module, exports) {

$parcel$export(module.exports, "noop", () => $b9e74c7f16476471$export$8793edee2d425525);
$parcel$export(module.exports, "autobindMethods", () => $b9e74c7f16476471$export$62974dc8053cca49);
$parcel$export(module.exports, "callOrAssign", () => $b9e74c7f16476471$export$d5f47afc7eea6932);
/* Riot WIP, @license MIT */ 
var $8kAdV = parcelRequire("8kAdV");
// does simply nothing
function $b9e74c7f16476471$export$8793edee2d425525() {
    return this;
}
/**
 * Autobind the methods of a source object to itself
 * @param   {Object} source - probably a riot tag instance
 * @param   {Array<string>} methods - list of the methods to autobind
 * @returns {Object} the original object received
 */ function $b9e74c7f16476471$export$62974dc8053cca49(source, methods) {
    methods.forEach((method)=>{
        source[method] = source[method].bind(source);
    });
    return source;
}
/**
 * Call the first argument received only if it's a function otherwise return it as it is
 * @param   {*} source - anything
 * @returns {*} anything
 */ function $b9e74c7f16476471$export$d5f47afc7eea6932(source) {
    return (0, $8kAdV.isFunction)(source) ? source.prototype && source.prototype.constructor ? new source() : source() : source;
}

});

parcelRegister("aem2Q", function(module, exports) {

$parcel$export(module.exports, "MOCKED_TEMPLATE_INTERFACE", () => $772c4fd85a1a44c9$export$1164b28605be0644);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $fGGec = parcelRequire("fGGec");

var $fXyIK = parcelRequire("fXyIK");
// Components without template use a mocked template interface with some basic functionalities to
// guarantee consistent rendering behaviour see https://github.com/riot/riot/issues/2984
const $772c4fd85a1a44c9$export$1164b28605be0644 = {
    [(0, $8VupT.MOUNT_METHOD_KEY)] (el) {
        this.el = el;
    },
    [(0, $8VupT.UPDATE_METHOD_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.UNMOUNT_METHOD_KEY)] (_, __, mustRemoveRoot = false) {
        if (mustRemoveRoot) (0, $fGGec.removeChild)(this.el);
        else if (!mustRemoveRoot) (0, $fGGec.cleanNode)(this.el);
    },
    clone () {
        return {
            ...this
        };
    },
    createDOM: (0, $fXyIK.noop)
};

});

parcelRegister("diRSU", function(module, exports) {

$parcel$export(module.exports, "componentTemplateFactory", () => $9af6c12e4df6b737$export$11f2fea361a206f0);
/* Riot v9.4.6, @license MIT */ 
var $3zqta = parcelRequire("3zqta");

var $dNFiL = parcelRequire("dNFiL");

var $f4jRS = parcelRequire("f4jRS");
/**
 * Factory function to create the component templates only once
 * @param   {Function} template - component template creation function
 * @param   {RiotComponentWrapper} componentWrapper - riot compiler generated object
 * @param   {Function} getChildComponent - getter function to return the children components
 * @returns {TemplateChunk} template chunk object
 */ function $9af6c12e4df6b737$export$11f2fea361a206f0(template, componentWrapper, getChildComponent) {
    return template((0, $3zqta.template), (0, $dNFiL.default), (0, $f4jRS.default), getChildComponent);
}

});

parcelRegister("cChHS", function(module, exports) {

$parcel$export(module.exports, "createPureComponent", () => $92f6c4cf9c901410$export$bcf29ba1633fa75c);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $koC5P = parcelRequire("koC5P");

var $3h6d1 = parcelRequire("3h6d1");

var $hFygz = parcelRequire("hFygz");

var $4zUod = parcelRequire("4zUod");

var $bzcog = parcelRequire("bzcog");
/**
 * Create a pure component
 * @param   {Function} pureFactoryFunction - pure component factory function
 * @param   {Array} options.slots - component slots
 * @param   {Array} options.attributes - component attributes
 * @param   {Array} options.template - template factory function
 * @param   {Array} options.template - template factory function
 * @param   {any} options.props - initial component properties
 * @returns {Object} pure component object
 */ function $92f6c4cf9c901410$export$bcf29ba1633fa75c(pureFactoryFunction, { slots: slots, attributes: attributes, props: props, css: css, template: template }) {
    if (template) (0, $koC5P.panic)('Pure components can not have html');
    if (css) (0, $koC5P.panic)('Pure components do not have css');
    const component = (0, $3h6d1.defineDefaults)(pureFactoryFunction({
        slots: slots,
        attributes: attributes,
        props: props
    }), (0, $hFygz.PURE_COMPONENT_API));
    return (0, $bzcog.createCoreAPIMethods)((method)=>(...args)=>{
            // intercept the mount calls to bind the DOM node to the pure object created
            // see also https://github.com/riot/riot/issues/2806
            if (method === (0, $8VupT.MOUNT_METHOD_KEY)) {
                const [element] = args;
                // mark this node as pure element
                (0, $3h6d1.defineProperty)(element, (0, $8VupT.IS_PURE_SYMBOL), true);
                (0, $4zUod.bindDOMNodeToComponentInstance)(element, component);
            }
            component[method](...args);
            return component;
        });
}

});
parcelRegister("hFygz", function(module, exports) {

$parcel$export(module.exports, "PURE_COMPONENT_API", () => $cdd0d8946835c0fe$export$eeadd4fe5e45d811);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $fXyIK = parcelRequire("fXyIK");
const $cdd0d8946835c0fe$export$eeadd4fe5e45d811 = Object.freeze({
    [(0, $8VupT.MOUNT_METHOD_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.UPDATE_METHOD_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.UNMOUNT_METHOD_KEY)]: (0, $fXyIK.noop)
});

});

parcelRegister("4zUod", function(module, exports) {

$parcel$export(module.exports, "bindDOMNodeToComponentInstance", () => $35562c186b3ff5be$export$13a682bc648ea731);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");
/**
 * Bind a DOM node to its component object
 * @param   {HTMLElement} node - html node mounted
 * @param   {Object} component - Riot.js component object
 * @returns {Object} the component object received as second argument
 */ const $35562c186b3ff5be$export$13a682bc648ea731 = (node, component)=>node[0, $8VupT.DOM_COMPONENT_INSTANCE_PROPERTY] = component;

});

parcelRegister("bzcog", function(module, exports) {

$parcel$export(module.exports, "createCoreAPIMethods", () => $86bc931490bdf2bd$export$c2b9b02153a7affa);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");
/**
 * Wrap the Riot.js core API methods using a mapping function
 * @param   {Function} mapFunction - lifting function
 * @returns {Object} an object having the { mount, update, unmount } functions
 */ function $86bc931490bdf2bd$export$c2b9b02153a7affa(mapFunction) {
    return [
        (0, $8VupT.MOUNT_METHOD_KEY),
        (0, $8VupT.UPDATE_METHOD_KEY),
        (0, $8VupT.UNMOUNT_METHOD_KEY)
    ].reduce((acc, method)=>{
        acc[method] = mapFunction(method);
        return acc;
    }, {});
}

});


parcelRegister("7G6OA", function(module, exports) {

$parcel$export(module.exports, "instantiateComponent", () => $5971bdf1f1024ec7$export$35b384e1d9a985a8);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $3h6d1 = parcelRequire("3h6d1");

var $lggro = parcelRequire("lggro");

var $7MrrT = parcelRequire("7MrrT");

var $97yfF = parcelRequire("97yfF");

var $efLP1 = parcelRequire("efLP1");

var $gyqQm = parcelRequire("gyqQm");
/**
 * Component definition function
 * @param   {Object} implementation - the component implementation will be generated via compiler
 * @param   {Object} component - the component initial properties
 * @returns {Object} a new component implementation object
 */ function $5971bdf1f1024ec7$export$35b384e1d9a985a8({ css: css, template: template, componentAPI: componentAPI, name: name }) {
    // add the component css into the DOM
    if (css && name) (0, $97yfF.default).add(name, css);
    return (0, $efLP1.default)((0, $gyqQm.manageComponentLifecycle))((0, $3h6d1.defineProperties)(// set the component defaults without overriding the original component API
    (0, $3h6d1.defineDefaults)(componentAPI, {
        ...(0, $7MrrT.COMPONENT_LIFECYCLE_METHODS),
        [(0, $8VupT.PROPS_KEY)]: {},
        [(0, $8VupT.STATE_KEY)]: {}
    }), {
        // defined during the component creation
        [(0, $8VupT.SLOTS_KEY)]: null,
        [(0, $8VupT.ROOT_KEY)]: null,
        // these properties should not be overriden
        ...(0, $lggro.COMPONENT_DOM_SELECTORS),
        name: name,
        css: css,
        template: template
    }));
}

});
parcelRegister("lggro", function(module, exports) {

$parcel$export(module.exports, "COMPONENT_DOM_SELECTORS", () => $f7a7d86bb4745ded$export$32f93d47894fcbb3);
/* Riot v9.4.6, @license MIT */ 
var $1NyWp = parcelRequire("1NyWp");
const $f7a7d86bb4745ded$export$32f93d47894fcbb3 = Object.freeze({
    // component helpers
    $ (selector) {
        return (0, $1NyWp.default)(selector, this.root)[0];
    },
    $$ (selector) {
        return (0, $1NyWp.default)(selector, this.root);
    }
});

});
parcelRegister("1NyWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $14f57898213ca2fd$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ 
var $ch0LT = parcelRequire("ch0LT");
/**
 * Simple helper to find DOM nodes returning them as array like loopable object
 * @param   { string|DOMNodeList } selector - either the query or the DOM nodes to arraify
 * @param   { HTMLElement }        scope      - context defining where the query will search for the DOM nodes
 * @returns { Array } DOM nodes found as array
 */ function $14f57898213ca2fd$export$2e2bcd8739ae039(selector, scope) {
    return (0, $ch0LT.default)(typeof selector === 'string' ? (scope || document).querySelectorAll(selector) : selector);
}

});
parcelRegister("ch0LT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ef7abc08ab92ece$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ /**
 * Converts any DOM node/s to a loopable array
 * @param   { HTMLElement|NodeList } els - single html element or a node list
 * @returns { Array } always a loopable object
 */ function $8ef7abc08ab92ece$export$2e2bcd8739ae039(els) {
    // can this object be already looped?
    if (!Array.isArray(els)) {
        // is it a node list?
        if (/^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(els)) && typeof els.length === 'number') return Array.from(els);
        else // if it's a single node
        // it will be returned as "array" with one single entry
        return [
            els
        ];
    }
    // this object could be looped out of the box
    return els;
}

});



parcelRegister("7MrrT", function(module, exports) {

$parcel$export(module.exports, "COMPONENT_LIFECYCLE_METHODS", () => $5aa24ee10826bdf2$export$1d962e041bb410fd);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $fXyIK = parcelRequire("fXyIK");
const $5aa24ee10826bdf2$export$1d962e041bb410fd = Object.freeze({
    [(0, $8VupT.SHOULD_UPDATE_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.ON_BEFORE_MOUNT_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.ON_MOUNTED_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.ON_BEFORE_UPDATE_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.ON_UPDATED_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.ON_BEFORE_UNMOUNT_KEY)]: (0, $fXyIK.noop),
    [(0, $8VupT.ON_UNMOUNTED_KEY)]: (0, $fXyIK.noop)
});

});

parcelRegister("97yfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a3f562abea2c771$export$2e2bcd8739ae039);
/* Riot v9.4.6, @license MIT */ 
var $1NyWp = parcelRequire("1NyWp");

var $jpTAJ = parcelRequire("jpTAJ");
const $6a3f562abea2c771$export$4b82df7571cd9ace = new Map();
const $6a3f562abea2c771$export$766ac0573f5f6e15 = 'style[riot]';
// memoized curried function
const $6a3f562abea2c771$var$getStyleNode = ((style)=>{
    return ()=>{
        // lazy evaluation:
        // if this function was already called before
        // we return its cached result
        if (style) return style;
        // create a new style element or use an existing one
        // and cache it internally
        style = (0, $1NyWp.default)($6a3f562abea2c771$export$766ac0573f5f6e15)[0] || document.createElement('style');
        (0, $jpTAJ.set)(style, 'type', 'text/css');
        /* istanbul ignore next */ if (!style.parentNode) document.head.appendChild(style);
        return style;
    };
})();
/**
 * Object that will be used to inject and manage the css of every tag instance
 */ const $6a3f562abea2c771$export$2e2bcd8739ae039 = {
    CSS_BY_NAME: $6a3f562abea2c771$export$4b82df7571cd9ace,
    /**
   * Save a tag style to be later injected into DOM
   * @param { string } name - if it's passed we will map the css to a tagname
   * @param { string } css - css string
   * @returns {Object} self
   */ add (name, css) {
        if (!$6a3f562abea2c771$export$4b82df7571cd9ace.has(name)) {
            $6a3f562abea2c771$export$4b82df7571cd9ace.set(name, css);
            this.inject();
        }
        return this;
    },
    /**
   * Inject all previously saved tag styles into DOM
   * innerHTML seems slow: http://jsperf.com/riot-insert-style
   * @returns {Object} self
   */ inject () {
        $6a3f562abea2c771$var$getStyleNode().innerHTML = [
            ...$6a3f562abea2c771$export$4b82df7571cd9ace.values()
        ].join('\n');
        return this;
    },
    /**
   * Remove a tag style from the DOM
   * @param {string} name a registered tagname
   * @returns {Object} self
   */ remove (name) {
        if ($6a3f562abea2c771$export$4b82df7571cd9ace.has(name)) {
            $6a3f562abea2c771$export$4b82df7571cd9ace.delete(name);
            this.inject();
        }
        return this;
    }
};

});
parcelRegister("jpTAJ", function(module, exports) {

$parcel$export(module.exports, "set", () => $e22b79667f52c90c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "get", () => $e22b79667f52c90c$export$3988ae62b71be9a3);
/* Riot WIP, @license MIT */ 
var $ch0LT = parcelRequire("ch0LT");
/**
 * Normalize the return values, in case of a single value we avoid to return an array
 * @param   { Array } values - list of values we want to return
 * @returns { Array|string|boolean } either the whole list of values or the single one found
 * @private
 */ const $e22b79667f52c90c$var$normalize = (values)=>values.length === 1 ? values[0] : values;
/**
 * Parse all the nodes received to get/remove/check their attributes
 * @param   { HTMLElement|NodeList|Array } els    - DOM node/s to parse
 * @param   { string|Array }               name   - name or list of attributes
 * @param   { string }                     method - method that will be used to parse the attributes
 * @returns { Array|string } result of the parsing in a list or a single value
 * @private
 */ function $e22b79667f52c90c$var$parseNodes(els, name, method) {
    const names = typeof name === 'string' ? [
        name
    ] : name;
    return $e22b79667f52c90c$var$normalize((0, $ch0LT.default)(els).map((el)=>{
        return $e22b79667f52c90c$var$normalize(names.map((n)=>el[method](n)));
    }));
}
/**
 * Set any attribute on a single or a list of DOM nodes
 * @param   { HTMLElement|NodeList|Array } els   - DOM node/s to parse
 * @param   { string|Object }              name  - either the name of the attribute to set
 *                                                 or a list of properties as object key - value
 * @param   { string }                     value - the new value of the attribute (optional)
 * @returns { HTMLElement|NodeList|Array } the original array of elements passed to this function
 *
 * @example
 *
 * import { set } from 'bianco.attr'
 *
 * const img = document.createElement('img')
 *
 * set(img, 'width', 100)
 *
 * // or also
 * set(img, {
 *   width: 300,
 *   height: 300
 * })
 *
 */ function $e22b79667f52c90c$export$adaa4cf7ef1b65be(els, name, value) {
    const attrs = typeof name === 'object' ? name : {
        [name]: value
    };
    const props = Object.keys(attrs);
    (0, $ch0LT.default)(els).forEach((el)=>{
        props.forEach((prop)=>el.setAttribute(prop, attrs[prop]));
    });
    return els;
}
/**
 * Get any attribute from a single or a list of DOM nodes
 * @param   { HTMLElement|NodeList|Array } els   - DOM node/s to parse
 * @param   { string|Array }               name  - name or list of attributes to get
 * @returns { Array|string } list of the attributes found
 *
 * @example
 *
 * import { get } from 'bianco.attr'
 *
 * const img = document.createElement('img')
 *
 * get(img, 'width') // => '200'
 *
 * // or also
 * get(img, ['width', 'height']) // => ['200', '300']
 *
 * // or also
 * get([img1, img2], ['width', 'height']) // => [['200', '300'], ['500', '200']]
 */ function $e22b79667f52c90c$export$3988ae62b71be9a3(els, name) {
    return $e22b79667f52c90c$var$parseNodes(els, name, 'getAttribute');
}

});


parcelRegister("efLP1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6078fd441ea7a19$export$2e2bcd8739ae039);
/* Riot WIP, @license MIT */ /**
 * Function to curry any javascript method
 * @param   {Function}  fn - the target function we want to curry
 * @param   {...[args]} acc - initial arguments
 * @returns {Function|*} it will return a function until the target function
 *                       will receive all of its arguments
 */ function $a6078fd441ea7a19$export$2e2bcd8739ae039(fn, ...acc) {
    return (...args)=>{
        args = [
            ...acc,
            ...args
        ];
        return args.length < fn.length ? $a6078fd441ea7a19$export$2e2bcd8739ae039(fn, ...args) : fn(...args);
    };
}

});

parcelRegister("gyqQm", function(module, exports) {

$parcel$export(module.exports, "manageComponentLifecycle", () => $c0d4a4e63564b38f$export$e8f3d389fde69f80);
/* Riot v9.4.6, @license MIT */ 
var $8kAdV = parcelRequire("8kAdV");

var $8VupT = parcelRequire("8VupT");

var $fGGec = parcelRequire("fGGec");

var $fXyIK = parcelRequire("fXyIK");

var $koC5P = parcelRequire("koC5P");

var $3h6d1 = parcelRequire("3h6d1");

var $9GvaL = parcelRequire("9GvaL");

var $4zUod = parcelRequire("4zUod");

var $hS7b7 = parcelRequire("hS7b7");

var $a0xLX = parcelRequire("a0xLX");

var $4FvxS = parcelRequire("4FvxS");

var $5SN8t = parcelRequire("5SN8t");

var $fIP49 = parcelRequire("fIP49");
/**
 * Component creation factory function that will enhance the user provided API
 * @param   {Object} component - a component implementation previously defined
 * @param   {Array} options.slots - component slots generated via riot compiler
 * @param   {Array} options.attributes - attribute expressions generated via riot compiler
 * @returns {Riot.Component} a riot component instance
 */ function $c0d4a4e63564b38f$export$e8f3d389fde69f80(component, { slots: slots, attributes: attributes, props: props }) {
    return (0, $fXyIK.autobindMethods)((0, $5SN8t.runPlugins)((0, $3h6d1.defineProperties)((0, $8kAdV.isObject)(component) ? Object.create(component) : component, {
        mount (element, state = {}, parentScope) {
            // any element mounted passing through this function can't be a pure component
            (0, $3h6d1.defineProperty)(element, (0, $8VupT.IS_PURE_SYMBOL), false);
            this[0, $8VupT.PARENT_KEY_SYMBOL] = parentScope;
            this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL] = (0, $4FvxS.createAttributeBindings)(element, attributes).mount(parentScope);
            (0, $3h6d1.defineProperty)(this, (0, $8VupT.PROPS_KEY), Object.freeze({
                ...(0, $a0xLX.computeInitialProps)(element, props),
                ...(0, $koC5P.evaluateAttributeExpressions)(this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL].expressions)
            }));
            this[0, $8VupT.STATE_KEY] = (0, $hS7b7.computeComponentState)(this[0, $8VupT.STATE_KEY], state);
            this[0, $8VupT.TEMPLATE_KEY_SYMBOL] = this.template.createDOM(element).clone();
            // link this object to the DOM node
            (0, $4zUod.bindDOMNodeToComponentInstance)(element, this);
            // add eventually the 'is' attribute
            component.name && (0, $9GvaL.addCssHook)(element, component.name);
            // define the root element
            (0, $3h6d1.defineProperty)(this, (0, $8VupT.ROOT_KEY), element);
            // define the slots array
            (0, $3h6d1.defineProperty)(this, (0, $8VupT.SLOTS_KEY), slots);
            // before mount lifecycle event
            this[0, $8VupT.ON_BEFORE_MOUNT_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            // mount the template
            this[0, $8VupT.TEMPLATE_KEY_SYMBOL].mount(element, this, parentScope);
            this[0, $8VupT.ON_MOUNTED_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            return this;
        },
        update (state = {}, parentScope) {
            if (parentScope) {
                this[0, $8VupT.PARENT_KEY_SYMBOL] = parentScope;
                this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL].update(parentScope);
            }
            // get the attribute names that don't belong to the the props object
            // this will avoid recursive props rendering https://github.com/riot/riot/issues/2994
            const computedAttributeNames = (0, $fIP49.getRootComputedAttributeNames)(this[0, $8VupT.TEMPLATE_KEY_SYMBOL]);
            // filter out the computed attributes from the root node
            const staticRootAttributes = Array.from(this[0, $8VupT.ROOT_KEY].attributes).filter(({ name: name })=>!computedAttributeNames.includes(name));
            // evaluate the value of the static dom attributes
            const domNodeAttributes = (0, $fGGec.DOMattributesToObject)({
                attributes: staticRootAttributes
            });
            // Avoid adding the riot "is" directives to the component props
            // eslint-disable-next-line no-unused-vars
            const { [(0, $8VupT.IS_DIRECTIVE)]: _, ...newProps } = {
                ...domNodeAttributes,
                ...(0, $koC5P.evaluateAttributeExpressions)(this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL].expressions)
            };
            if (this[0, $8VupT.SHOULD_UPDATE_KEY](newProps, this[0, $8VupT.PROPS_KEY]) === false) return;
            (0, $3h6d1.defineProperty)(this, (0, $8VupT.PROPS_KEY), Object.freeze({
                // only root components will merge their initial props with the new ones
                // children components will just get them overridden see also https://github.com/riot/riot/issues/2978
                ...parentScope ? (0, $3h6d1.pick)(this[0, $8VupT.PROPS_KEY], computedAttributeNames) : this[0, $8VupT.PROPS_KEY],
                ...newProps
            }));
            this[0, $8VupT.STATE_KEY] = (0, $hS7b7.computeComponentState)(this[0, $8VupT.STATE_KEY], state);
            this[0, $8VupT.ON_BEFORE_UPDATE_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            // avoiding recursive updates
            // see also https://github.com/riot/riot/issues/2895
            if (!this[0, $8VupT.IS_COMPONENT_UPDATING]) {
                this[0, $8VupT.IS_COMPONENT_UPDATING] = true;
                this[0, $8VupT.TEMPLATE_KEY_SYMBOL].update(this, this[0, $8VupT.PARENT_KEY_SYMBOL]);
            }
            this[0, $8VupT.ON_UPDATED_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            this[0, $8VupT.IS_COMPONENT_UPDATING] = false;
            return this;
        },
        unmount (preserveRoot) {
            this[0, $8VupT.ON_BEFORE_UNMOUNT_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            this[0, $8VupT.ATTRIBUTES_KEY_SYMBOL].unmount();
            // if the preserveRoot is null the template html will be left untouched
            // in that case the DOM cleanup will happen differently from a parent node
            this[0, $8VupT.TEMPLATE_KEY_SYMBOL].unmount(this, this[0, $8VupT.PARENT_KEY_SYMBOL], preserveRoot === null ? null : !preserveRoot);
            this[0, $8VupT.ON_UNMOUNTED_KEY](this[0, $8VupT.PROPS_KEY], this[0, $8VupT.STATE_KEY]);
            return this;
        }
    })), Object.keys(component).filter((prop)=>(0, $8kAdV.isFunction)(component[prop])));
}

});
parcelRegister("9GvaL", function(module, exports) {

$parcel$export(module.exports, "addCssHook", () => $70d03789717093c3$export$b1e7cc44c66b1d10);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $26y35 = parcelRequire("26y35");

var $jpTAJ = parcelRequire("jpTAJ");
/**
 * Add eventually the "is" attribute to link this DOM node to its css
 * @param {HTMLElement} element - target root node
 * @param {string} name - name of the component mounted
 * @returns {undefined} it's a void function
 */ function $70d03789717093c3$export$b1e7cc44c66b1d10(element, name) {
    if ((0, $26y35.getName)(element) !== name) (0, $jpTAJ.set)(element, (0, $8VupT.IS_DIRECTIVE), name);
}

});
parcelRegister("26y35", function(module, exports) {

$parcel$export(module.exports, "getName", () => $18868db33d6e0d4a$export$7d9f7e9c1c02b41e);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");

var $jpTAJ = parcelRequire("jpTAJ");
/**
 * Get the tag name of any DOM node
 * @param   {HTMLElement} element - DOM node we want to inspect
 * @returns {string} name to identify this dom node in riot
 */ function $18868db33d6e0d4a$export$7d9f7e9c1c02b41e(element) {
    return (0, $jpTAJ.get)(element, (0, $8VupT.IS_DIRECTIVE)) || element.tagName.toLowerCase();
}

});


parcelRegister("hS7b7", function(module, exports) {

$parcel$export(module.exports, "computeComponentState", () => $d02d0c4220ab9a69$export$c38901fc82272303);
/* Riot v9.4.6, @license MIT */ 
var $fXyIK = parcelRequire("fXyIK");
/**
 * Compute the component current state merging it with its previous state
 * @param   {Object} oldState - previous state object
 * @param   {Object} newState - new state given to the `update` call
 * @returns {Object} new object state
 */ function $d02d0c4220ab9a69$export$c38901fc82272303(oldState, newState) {
    return {
        ...oldState,
        ...(0, $fXyIK.callOrAssign)(newState)
    };
}

});

parcelRegister("a0xLX", function(module, exports) {

$parcel$export(module.exports, "computeInitialProps", () => $74941a00ae0ff2fa$export$7a75a69d6efa39f3);
/* Riot v9.4.6, @license MIT */ 
var $fGGec = parcelRequire("fGGec");

var $fXyIK = parcelRequire("fXyIK");
/**
 * Evaluate the component properties either from its real attributes or from its initial user properties
 * @param   {HTMLElement} element - component root
 * @param   {Object}  initialProps - initial props
 * @returns {Object} component props key value pairs
 */ function $74941a00ae0ff2fa$export$7a75a69d6efa39f3(element, initialProps = {}) {
    return {
        ...(0, $fGGec.DOMattributesToObject)(element),
        ...(0, $fXyIK.callOrAssign)(initialProps)
    };
}

});

parcelRegister("4FvxS", function(module, exports) {

$parcel$export(module.exports, "createAttributeBindings", () => $366376093a62b66a$export$31e380557e4223c9);
/* Riot v9.4.6, @license MIT */ 
var $bzcog = parcelRequire("bzcog");

var $3zqta = parcelRequire("3zqta");
/**
 * Create the bindings to update the component attributes
 * @param   {HTMLElement} node - node where we will bind the expressions
 * @param   {Array} attributes - list of attribute bindings
 * @returns {TemplateChunk} - template bindings object
 */ function $366376093a62b66a$export$31e380557e4223c9(node, attributes = []) {
    const expressions = attributes.map((a)=>(0, $3zqta.createExpression)(node, a));
    const binding = {};
    return Object.assign(binding, {
        expressions: expressions,
        ...(0, $bzcog.createCoreAPIMethods)((method)=>(scope)=>{
                expressions.forEach((e)=>e[method](scope));
                return binding;
            })
    });
}

});

parcelRegister("5SN8t", function(module, exports) {

$parcel$export(module.exports, "runPlugins", () => $44881c3572404721$export$c9f2a3c710939a17);
/* Riot v9.4.6, @license MIT */ 
var $8VupT = parcelRequire("8VupT");
/**
 * Run the component instance through all the plugins set by the user
 * @param   {Object} component - component instance
 * @returns {Object} the component enhanced by the plugins
 */ function $44881c3572404721$export$c9f2a3c710939a17(component) {
    return [
        ...(0, $8VupT.PLUGINS_SET)
    ].reduce((c, fn)=>fn(c) || c, component);
}

});

parcelRegister("fIP49", function(module, exports) {

$parcel$export(module.exports, "getRootComputedAttributeNames", () => $b72293b1b181ed84$export$e6df2a6c12fb95fe);
/* Riot v9.4.6, @license MIT */ 

var $dNFiL = parcelRequire("dNFiL");

var $koC5P = parcelRequire("koC5P");
/**
 * Get the computed attribute names from the template instance
 * Since these attributes will not change we memoize the result of this computation
 * @param {TemplateChunk} template - template instance
 * @return {[]} list of attribute names that will be computed by the template expressions
 */ const $b72293b1b181ed84$export$e6df2a6c12fb95fe = (0, $koC5P.memoize)((template)=>{
    const firstBinding = template?.bindingsData?.[0];
    // if the first binding has the selector attribute it means that it doesn't belong to the root node
    if (firstBinding?.selector) return [];
    return firstBinding?.expressions?.reduce((acc, { name: name, type: type })=>type === (0, $dNFiL.default).ATTRIBUTE ? acc.concat([
            name
        ]) : acc, []) ?? [];
});

});





parcelRegister("jR26U", function(module, exports) {

$parcel$export(module.exports, "pure", () => $e7449aa0fe4278d9$export$48ec4a2b1cfc6557);
/* Riot v9.4.6, @license MIT */ 
var $8kAdV = parcelRequire("8kAdV");

var $8VupT = parcelRequire("8VupT");

var $koC5P = parcelRequire("koC5P");
/**
 * Lift a riot component Interface into a pure riot object
 * @param   {Function} func - RiotPureComponent factory function
 * @returns {Function} the lifted original function received as argument
 */ function $e7449aa0fe4278d9$export$48ec4a2b1cfc6557(func) {
    if (!(0, $8kAdV.isFunction)(func)) (0, $koC5P.panic)('riot.pure accepts only arguments of type "function"');
    func[0, $8VupT.IS_PURE_SYMBOL] = true;
    return func;
}

});

parcelRegister("507si", function(module, exports) {

$parcel$export(module.exports, "cleanNode", () => $3a42bc518fd572fe$export$9497debfa326231a);

var $1tYT4 = parcelRequire("1tYT4");
function $3a42bc518fd572fe$export$f5c4414827140849(element) {
    return Array.from(element.attributes).reduce((acc, attribute)=>{
        acc[(0, $1tYT4.dashToCamelCase)(attribute.name)] = attribute.value;
        return acc;
    }, {});
}
function $3a42bc518fd572fe$export$434b8be66f8c2ac9(source, target) {
    // eslint-disable-next-line fp/no-loops
    while(source.firstChild)target.appendChild(source.firstChild);
}
function $3a42bc518fd572fe$export$9497debfa326231a(node) {
    // eslint-disable-next-line fp/no-loops
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $3a42bc518fd572fe$export$da51b626bd37c807(children) {
    // eslint-disable-next-line fp/no-loops,fp/no-let
    for(let i = 0; i < children.length; i++)$3a42bc518fd572fe$export$7ae609f7af59e4f7(children[i]);
}
const $3a42bc518fd572fe$export$7ae609f7af59e4f7 = (node)=>node.remove();
const $3a42bc518fd572fe$export$86b68c7dbeb53c22 = (newNode, refNode)=>refNode && refNode.parentNode && refNode.parentNode.insertBefore(newNode, refNode);
const $3a42bc518fd572fe$export$46f78da0e790aab7 = (newNode, replaced)=>replaced && replaced.parentNode && replaced.parentNode.replaceChild(newNode, replaced);

});
parcelRegister("1tYT4", function(module, exports) {

$parcel$export(module.exports, "dashToCamelCase", () => $1147bad3c88018a6$export$138f9917dd6248b4);
/**
 * Convert a string from camel case to dash-case
 * @param   {string} string - probably a component tag name
 * @returns {string} component name normalized
 */ function $1147bad3c88018a6$export$6e116da553d9a4d8(string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $1147bad3c88018a6$export$138f9917dd6248b4(string) {
    return string.replace(/-(\w)/g, (_, c)=>c.toUpperCase());
}

});



parcelRegister("6CXec", function(module, exports) {

$parcel$export(module.exports, "TOKEN_KEY", () => $4d343c1e059cfbce$export$5fa58d0d5feabf48);
$parcel$export(module.exports, "EMAIL_KEY", () => $4d343c1e059cfbce$export$8174500baa6eca79);
const $4d343c1e059cfbce$export$5fa58d0d5feabf48 = 'token';
const $4d343c1e059cfbce$export$8174500baa6eca79 = 'email';

});

parcelRegister("lEDqY", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1vVfW").then(()=>parcelRequire('439V6'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("9kWNq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8LJt1"),
    $Gr8vk("IZuga")
]).then(()=>parcelRequire('lKpru'));

});

parcelRegister("agqgZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8LJt1"),
    $Gr8vk("lDUZK")
]).then(()=>parcelRequire('kxdC2'));

});

parcelRegister("d29hn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lEQB3").then(()=>parcelRequire('26Rot'));

});

parcelRegister("auyGb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8LJt1"),
    $Gr8vk("1bF9q")
]).then(()=>parcelRequire('lSpzJ'));

});

parcelRegister("6IKPj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8LJt1"),
    $Gr8vk("bUioR")
]).then(()=>parcelRequire('h5RCI'));

});

var $718dd0dc1ce98c14$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"jRPZQ\",\"index.f57a696c.js\",\"1vVfW\",\"topnav.f90e53ee.js\",\"IZuga\",\"login.4298be94.js\",\"8LJt1\",\"login.e9e9863a.js\",\"lDUZK\",\"verify.7f4fac61.js\",\"lEQB3\",\"today.16178da6.js\",\"eECG6\",\"events.0749b17b.js\",\"2wavd\",\"dinner.4b616bc9.js\",\"2zUbT\",\"sports.5d5a0c07.js\",\"aHuLS\",\"stocks.97346de5.js\",\"4gJZw\",\"news.54907676.js\",\"1bF9q\",\"weather.bff30c6f.js\",\"bUioR\",\"homectrl.aeba9271.js\",\"cEdrq\",\"door.9af995a8.js\"]"));


var $84N1j = parcelRequire("84N1j");

var $av5wi = parcelRequire("av5wi");

var $6CXec = parcelRequire("6CXec");
function $01a9cfedaf3efba8$var$connectTabs() {
    const tabs = document.querySelectorAll('.bottom-nav a');
    const sections = document.querySelectorAll('#content-wrapper .section');
    const blankSection = document.querySelector('#blank');
    tabs.forEach((tab)=>{
        tab.addEventListener('click', (event)=>{
            event.preventDefault(); // Prevent page jump
            tabs.forEach((t)=>t.classList.remove('active'));
            tab.classList.add('active');
            sections.forEach((section)=>section.style.display = 'none');
            blankSection.style.display = 'block';
            setTimeout(()=>{
                document.getElementById(tab.dataset.target).style.display = 'block';
                blankSection.style.display = 'none';
            }, 25);
        });
    });
}






var $01a9cfedaf3efba8$export$2e2bcd8739ae039 = {
    css: null,
    exports: {
        state: {
            loginState: ''
        },
        components: {
            topnav: (0, $av5wi.default)(()=>(parcelRequire("lEDqY"))),
            login: (0, $av5wi.default)(()=>(parcelRequire("9kWNq"))),
            verify: (0, $av5wi.default)(()=>(parcelRequire("agqgZ"))),
            today: (0, $av5wi.default)(()=>(parcelRequire("d29hn"))),
            weather: (0, $av5wi.default)(()=>(parcelRequire("auyGb"))),
            homectrl: (0, $av5wi.default)(()=>(parcelRequire("6IKPj")))
        },
        onMounted (props, state) {
            const token = localStorage.getItem((0, $6CXec.TOKEN_KEY));
            if (token) {
                this.update({
                    loginState: 'auth'
                });
                $01a9cfedaf3efba8$var$connectTabs();
            }
        },
        onUpdateAuth (ev) {
            this.update({
                loginState: ev.loginState
            });
            if (ev.loginState == 'auth') $01a9cfedaf3efba8$var$connectTabs();
        }
    },
    template: (template, expressionTypes, bindingTypes, getComponent)=>template('<template expr0="expr0"></template><template expr2="expr2"></template><template expr4="expr4"></template>', [
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.loginState == '',
                redundantAttribute: 'expr0',
                selector: '[expr0]',
                template: template('<login expr1="expr1"></login>', [
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'login',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'on-auth',
                                evaluate: (_scope)=>_scope.onUpdateAuth
                            }
                        ],
                        redundantAttribute: 'expr1',
                        selector: '[expr1]'
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.loginState == 'verify',
                redundantAttribute: 'expr2',
                selector: '[expr2]',
                template: template('<verify expr3="expr3"></verify>', [
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'verify',
                        slots: [],
                        attributes: [
                            {
                                type: expressionTypes.EVENT,
                                name: 'on-verify',
                                evaluate: (_scope)=>_scope.onUpdateAuth
                            }
                        ],
                        redundantAttribute: 'expr3',
                        selector: '[expr3]'
                    }
                ])
            },
            {
                type: bindingTypes.IF,
                evaluate: (_scope)=>_scope.state.loginState == 'auth',
                redundantAttribute: 'expr4',
                selector: '[expr4]',
                template: template('<topnav expr5="expr5"></topnav><div id="content-wrapper"><section id="today" class="section"><today expr6="expr6"></today></section><section id="weather" class="section" style="display: none;"><weather expr7="expr7"></weather></section><section id="home-controls" class="section" style="display: none;"><homectrl expr8="expr8"></homectrl></section><section id="blank" class="section" style="display: none;"></section></div><nav class="bottom-nav"><a href="#" class="active" data-target="today"><i class="fas fa-calendar-check fa-2x"></i><span>Today</span></a><a href="#" data-target="weather"><i class="fas fa-cloud-sun fa-2x"></i><span>Weather</span></a><a href="#" data-target="home-controls"><i class="fas fa-home fa-2x"></i><span>Home Ctrl</span></a></nav>', [
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'topnav',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr5',
                        selector: '[expr5]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'today',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr6',
                        selector: '[expr6]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'weather',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr7',
                        selector: '[expr7]'
                    },
                    {
                        type: bindingTypes.TAG,
                        getComponent: getComponent,
                        evaluate: (_scope)=>'homectrl',
                        slots: [],
                        attributes: [],
                        redundantAttribute: 'expr8',
                        selector: '[expr8]'
                    }
                ])
            }
        ]),
    name: 'app'
};


var $38157fdff20369a3$exports = {};
/*!
 * pulltorefreshjs v0.1.22
 * (c) Rafael Soto
 * Released under the MIT License.
 */ (function(global, factory) {
    $38157fdff20369a3$exports = factory();
})($38157fdff20369a3$exports, function() {
    'use strict';
    var _shared = {
        pullStartY: null,
        pullMoveY: null,
        handlers: [],
        styleEl: null,
        events: null,
        dist: 0,
        state: 'pending',
        timeout: null,
        distResisted: 0,
        supportsPassive: false,
        supportsPointerEvents: typeof window !== 'undefined' && !!window.PointerEvent
    };
    try {
        window.addEventListener('test', null, {
            get passive () {
                // eslint-disable-line getter-return
                _shared.supportsPassive = true;
            }
        });
    } catch (e) {}
    function setupDOM(handler) {
        if (!handler.ptrElement) {
            var ptr = document.createElement('div');
            if (handler.mainElement !== document.body) handler.mainElement.parentNode.insertBefore(ptr, handler.mainElement);
            else document.body.insertBefore(ptr, document.body.firstChild);
            ptr.classList.add(handler.classPrefix + "ptr");
            ptr.innerHTML = handler.getMarkup().replace(/__PREFIX__/g, handler.classPrefix);
            handler.ptrElement = ptr;
            if (typeof handler.onInit === 'function') handler.onInit(handler);
             // Add the css styles to the style node, and then
            // insert it into the dom
            if (!_shared.styleEl) {
                _shared.styleEl = document.createElement('style');
                _shared.styleEl.setAttribute('id', 'pull-to-refresh-js-style');
                document.head.appendChild(_shared.styleEl);
            }
            _shared.styleEl.textContent = handler.getStyles().replace(/__PREFIX__/g, handler.classPrefix).replace(/\s+/g, ' ');
        }
        return handler;
    }
    function onReset(handler) {
        if (!handler.ptrElement) return;
        handler.ptrElement.classList.remove(handler.classPrefix + "refresh");
        handler.ptrElement.style[handler.cssProp] = '0px';
        setTimeout(function() {
            // remove previous ptr-element from DOM
            if (handler.ptrElement && handler.ptrElement.parentNode) {
                handler.ptrElement.parentNode.removeChild(handler.ptrElement);
                handler.ptrElement = null;
            } // reset state
            _shared.state = 'pending';
        }, handler.refreshTimeout);
    }
    function update(handler) {
        var iconEl = handler.ptrElement.querySelector("." + handler.classPrefix + "icon");
        var textEl = handler.ptrElement.querySelector("." + handler.classPrefix + "text");
        if (iconEl) {
            if (_shared.state === 'refreshing') iconEl.innerHTML = handler.iconRefreshing;
            else iconEl.innerHTML = handler.iconArrow;
        }
        if (textEl) {
            if (_shared.state === 'releasing') textEl.innerHTML = handler.instructionsReleaseToRefresh;
            if (_shared.state === 'pulling' || _shared.state === 'pending') textEl.innerHTML = handler.instructionsPullToRefresh;
            if (_shared.state === 'refreshing') textEl.innerHTML = handler.instructionsRefreshing;
        }
    }
    var _ptr = {
        setupDOM: setupDOM,
        onReset: onReset,
        update: update
    };
    var _timeout;
    var screenY = function screenY(event) {
        if (_shared.pointerEventsEnabled && _shared.supportsPointerEvents) return event.screenY;
        return event.touches[0].screenY;
    };
    var _setupEvents = function() {
        var _el;
        function _onTouchStart(e) {
            // here, we must pick a handler first, and then append their html/css on the DOM
            var target = _shared.handlers.filter(function(h) {
                return h.contains(e.target);
            })[0];
            _shared.enable = !!target;
            if (target && _shared.state === 'pending') {
                _el = _ptr.setupDOM(target);
                if (target.shouldPullToRefresh()) _shared.pullStartY = screenY(e);
                clearTimeout(_shared.timeout);
                _ptr.update(target);
            }
        }
        function _onTouchMove(e) {
            if (!(_el && _el.ptrElement && _shared.enable)) return;
            if (!_shared.pullStartY) {
                if (_el.shouldPullToRefresh()) _shared.pullStartY = screenY(e);
            } else _shared.pullMoveY = screenY(e);
            if (_shared.state === 'refreshing') {
                if (e.cancelable && _el.shouldPullToRefresh() && _shared.pullStartY < _shared.pullMoveY) e.preventDefault();
                return;
            }
            if (_shared.state === 'pending') {
                _el.ptrElement.classList.add(_el.classPrefix + "pull");
                _shared.state = 'pulling';
                _ptr.update(_el);
            }
            if (_shared.pullStartY && _shared.pullMoveY) _shared.dist = _shared.pullMoveY - _shared.pullStartY;
            _shared.distExtra = _shared.dist - _el.distIgnore;
            if (_shared.distExtra > 0) {
                if (e.cancelable) e.preventDefault();
                _el.ptrElement.style[_el.cssProp] = _shared.distResisted + "px";
                _shared.distResisted = _el.resistanceFunction(_shared.distExtra / _el.distThreshold) * Math.min(_el.distMax, _shared.distExtra);
                if (_shared.state === 'pulling' && _shared.distResisted > _el.distThreshold) {
                    _el.ptrElement.classList.add(_el.classPrefix + "release");
                    _shared.state = 'releasing';
                    _ptr.update(_el);
                }
                if (_shared.state === 'releasing' && _shared.distResisted < _el.distThreshold) {
                    _el.ptrElement.classList.remove(_el.classPrefix + "release");
                    _shared.state = 'pulling';
                    _ptr.update(_el);
                }
            }
        }
        function _onTouchEnd() {
            if (!(_el && _el.ptrElement && _shared.enable)) return;
             // wait 1/2 sec before unmounting...
            clearTimeout(_timeout);
            _timeout = setTimeout(function() {
                if (_el && _el.ptrElement && _shared.state === 'pending') _ptr.onReset(_el);
            }, 500);
            if (_shared.state === 'releasing' && _shared.distResisted > _el.distThreshold) {
                _shared.state = 'refreshing';
                _el.ptrElement.style[_el.cssProp] = _el.distReload + "px";
                _el.ptrElement.classList.add(_el.classPrefix + "refresh");
                _shared.timeout = setTimeout(function() {
                    var retval = _el.onRefresh(function() {
                        return _ptr.onReset(_el);
                    });
                    if (retval && typeof retval.then === 'function') retval.then(function() {
                        return _ptr.onReset(_el);
                    });
                    if (!retval && !_el.onRefresh.length) _ptr.onReset(_el);
                }, _el.refreshTimeout);
            } else {
                if (_shared.state === 'refreshing') return;
                _el.ptrElement.style[_el.cssProp] = '0px';
                _shared.state = 'pending';
            }
            _ptr.update(_el);
            _el.ptrElement.classList.remove(_el.classPrefix + "release");
            _el.ptrElement.classList.remove(_el.classPrefix + "pull");
            _shared.pullStartY = _shared.pullMoveY = null;
            _shared.dist = _shared.distResisted = 0;
        }
        function _onScroll() {
            if (_el) _el.mainElement.classList.toggle(_el.classPrefix + "top", _el.shouldPullToRefresh());
        }
        var _passiveSettings = _shared.supportsPassive ? {
            passive: _shared.passive || false
        } : undefined;
        if (_shared.pointerEventsEnabled && _shared.supportsPointerEvents) {
            window.addEventListener('pointerup', _onTouchEnd);
            window.addEventListener('pointerdown', _onTouchStart);
            window.addEventListener('pointermove', _onTouchMove, _passiveSettings);
        } else {
            window.addEventListener('touchend', _onTouchEnd);
            window.addEventListener('touchstart', _onTouchStart);
            window.addEventListener('touchmove', _onTouchMove, _passiveSettings);
        }
        window.addEventListener('scroll', _onScroll);
        return {
            onTouchEnd: _onTouchEnd,
            onTouchStart: _onTouchStart,
            onTouchMove: _onTouchMove,
            onScroll: _onScroll,
            destroy: function destroy() {
                if (_shared.pointerEventsEnabled && _shared.supportsPointerEvents) {
                    window.removeEventListener('pointerdown', _onTouchStart);
                    window.removeEventListener('pointerup', _onTouchEnd);
                    window.removeEventListener('pointermove', _onTouchMove, _passiveSettings);
                } else {
                    window.removeEventListener('touchstart', _onTouchStart);
                    window.removeEventListener('touchend', _onTouchEnd);
                    window.removeEventListener('touchmove', _onTouchMove, _passiveSettings);
                }
                window.removeEventListener('scroll', _onScroll);
            }
        };
    };
    var _ptrMarkup = "\n<div class=\"__PREFIX__box\">\n  <div class=\"__PREFIX__content\">\n    <div class=\"__PREFIX__icon\"></div>\n    <div class=\"__PREFIX__text\"></div>\n  </div>\n</div>\n";
    var _ptrStyles = "\n.__PREFIX__ptr {\n  box-shadow: inset 0 -3px 5px rgba(0, 0, 0, 0.12);\n  pointer-events: none;\n  font-size: 0.85em;\n  font-weight: bold;\n  top: 0;\n  height: 0;\n  transition: height 0.3s, min-height 0.3s;\n  text-align: center;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-end;\n  align-content: stretch;\n}\n\n.__PREFIX__box {\n  padding: 10px;\n  flex-basis: 100%;\n}\n\n.__PREFIX__pull {\n  transition: none;\n}\n\n.__PREFIX__text {\n  margin-top: .33em;\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.__PREFIX__icon {\n  color: rgba(0, 0, 0, 0.3);\n  transition: transform .3s;\n}\n\n/*\nWhen at the top of the page, disable vertical overscroll so passive touch\nlisteners can take over.\n*/\n.__PREFIX__top {\n  touch-action: pan-x pan-down pinch-zoom;\n}\n\n.__PREFIX__release .__PREFIX__icon {\n  transform: rotate(180deg);\n}\n";
    var _defaults = {
        distThreshold: 60,
        distMax: 80,
        distReload: 50,
        distIgnore: 0,
        mainElement: 'body',
        triggerElement: 'body',
        ptrElement: '.ptr',
        classPrefix: 'ptr--',
        cssProp: 'min-height',
        iconArrow: '&#8675;',
        iconRefreshing: '&hellip;',
        instructionsPullToRefresh: 'Pull down to refresh',
        instructionsReleaseToRefresh: 'Release to refresh',
        instructionsRefreshing: 'Refreshing',
        refreshTimeout: 500,
        getMarkup: function() {
            return _ptrMarkup;
        },
        getStyles: function() {
            return _ptrStyles;
        },
        onInit: function() {},
        onRefresh: function() {
            return location.reload();
        },
        resistanceFunction: function(t) {
            return Math.min(1, t / 2.5);
        },
        shouldPullToRefresh: function() {
            return !window.scrollY;
        }
    };
    var _methods = [
        'mainElement',
        'ptrElement',
        'triggerElement'
    ];
    var _setupHandler = function(options) {
        var _handler = {}; // merge options with defaults
        Object.keys(_defaults).forEach(function(key) {
            _handler[key] = options[key] || _defaults[key];
        }); // normalize timeout value, even if it is zero
        _handler.refreshTimeout = typeof options.refreshTimeout === 'number' ? options.refreshTimeout : _defaults.refreshTimeout; // normalize elements
        _methods.forEach(function(method) {
            if (typeof _handler[method] === 'string') _handler[method] = document.querySelector(_handler[method]);
        }); // attach events lazily
        if (!_shared.events) _shared.events = _setupEvents();
        _handler.contains = function(target) {
            return _handler.triggerElement.contains(target);
        };
        _handler.destroy = function() {
            // stop pending any pending callbacks
            clearTimeout(_shared.timeout); // remove handler from shared state
            var offset = _shared.handlers.indexOf(_handler);
            _shared.handlers.splice(offset, 1);
        };
        return _handler;
    };
    var index = {
        setPassiveMode: function setPassiveMode(isPassive) {
            _shared.passive = isPassive;
        },
        setPointerEventsMode: function setPointerEventsMode(isEnabled) {
            _shared.pointerEventsEnabled = isEnabled;
        },
        destroyAll: function destroyAll() {
            if (_shared.events) {
                _shared.events.destroy();
                _shared.events = null;
            }
            _shared.handlers.forEach(function(h) {
                h.destroy();
            });
        },
        init: function init(options) {
            if (options === void 0) options = {};
            var handler = _setupHandler(options);
            _shared.handlers.push(handler);
            return handler;
        },
        // export utils for testing
        _: {
            setupHandler: _setupHandler,
            setupEvents: _setupEvents,
            setupDOM: _ptr.setupDOM,
            onReset: _ptr.onReset,
            update: _ptr.update
        }
    };
    return index;
});


const $6b17f08f738443dc$var$ptr = (0, (/*@__PURE__*/$parcel$interopDefault($38157fdff20369a3$exports))).init({
    mainElement: 'body',
    onRefresh () {
        window.location.reload();
    }
});
const $6b17f08f738443dc$var$mountApp = $84N1j.component((0, $01a9cfedaf3efba8$export$2e2bcd8739ae039));
const $6b17f08f738443dc$var$app = $6b17f08f738443dc$var$mountApp(document.getElementById('appContainer'), {});


//# sourceMappingURL=index.f57a696c.js.map
